import React from "react";
// import "../../../node_modules/react-grid-layout/css/styles.css";
// import "../../../node_modules/react-resizable/css/styles.css";
// import GridLayout from "react-grid-layout";
import axios from "axios";
import API_URL from "../../constants/API_URL";
import { IoMdCheckmarkCircleOutline, IoMdClose } from "react-icons/io";
import {
  FaArrowLeft,
  FaArrowRight,
  FaCheck,
  FaFirstOrder,
  FaFirstOrderAlt,
  FaSortAlphaDown,
  FaSortAlphaDownAlt,
  FaSortNumericDown,
  FaSortNumericDownAlt,
  FaUserLock,
} from "react-icons/fa";
import {
  BsArrowsFullscreen,
  BsCashStack,
  BsFillPersonLinesFill,
  BsFullscreen,
  BsFullscreenExit,
  BsWrenchAdjustable,
} from "react-icons/bs";
import { IoIosArrowDown, IoMdSettings } from "react-icons/io";
import Swal from "sweetalert2";
import {
  Tabs,
  notification,
  Button,
  Row,
  Col,
  message,
  Modal,
  Badge,
  Tooltip,
  InputNumber,
  Select,
  Input,
  DatePicker,
  Table,
  Form,
  Icon,
  Card,
  Checkbox,
  Switch,
  Dropdown,
  Menu,
} from "antd";
import { DragDropContextProvider, DragSource, DropTarget } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import PosChildContainer from "../PosChildContainer/PosChildContainer";
import "./pos.css";
import { buildMessage } from "./print";
import WEBSOCKET_API from "../../constants/WEBSOCKET_API";
import { cashUpPrint } from "./print";
import OnlineOrdersList from "../OnlineSaleOrderList/OnlineSaleOrderList";
import FormItem from "antd/lib/form/FormItem";
import { connect } from "react-redux";
import { posStorageAction } from "../../redux/actions/posStorageAction";
import Timer from "./Timer";
import PaymentPopUp from "./PaymentPopUp";
import CancelItemsList from "./CancelItemsList";
import CancelOrdersList from "./CancelOrdersList";
import moment from "moment";
import FormCashup from "./FormCashup";
import { data } from "flickity";
import { reject } from "lodash";
import { Link } from "react-router-dom";
import { FaArrowRotateLeft, FaBarsProgress } from "react-icons/fa6";
import {
  MdFiberNew,
  MdFullscreen,
  MdManageSearch,
  MdOutlineFullscreenExit,
  MdOutlineOnlinePrediction,
  MdPlaylistAddCircle,
} from "react-icons/md";
import { MdTableBar } from "react-icons/md";
import { clear } from "idb-keyval";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { IoArrowRedoOutline } from "react-icons/io5";

const { TabPane } = Tabs;
const { confirm } = Modal;

class TabNode extends React.Component {
  render() {
    const { connectDragSource, connectDropTarget, children } = this.props;
    return connectDragSource(connectDropTarget(children));
  }
}

const cardTarget = {
  drop(props, monitor) {
    const dragKey = monitor.getItem().index;
    const hoverKey = props.index;

    if (dragKey === hoverKey) {
      return;
    }

    props.moveTabNode(dragKey, hoverKey);
    monitor.getItem().index = hoverKey;
  },
};

const cardSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },
};

const WrapTabNode = DropTarget("DND_NODE", cardTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(
  DragSource("DND_NODE", cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }))(TabNode),
);

class DraggableTabs extends React.Component {
  state = {
    order: [],
    visible: false,
    visible2: false,
    orderSearchVisible: false,
    onlineOrdersListOpens: false,
    showButton: true,
    orderReturn: false,
  };
  showButton = () => {
    this.setState({ showButton: false });
  };
  moveTabNode = (dragKey, hoverKey) => {
    const newOrder = this.state.order.slice();
    const { children } = this.props;

    React.Children.forEach(children, (c) => {
      if (newOrder.indexOf(c.key) === -1) {
        newOrder.push(c.key);
      }
    });

    const dragIndex = newOrder.indexOf(dragKey);
    const hoverIndex = newOrder.indexOf(hoverKey);

    newOrder.splice(dragIndex, 1);
    newOrder.splice(hoverIndex, 0, dragKey);

    this.setState({
      order: newOrder,
    });
  };

  renderTabBar = (props, DefaultTabBar) => (
    <DefaultTabBar {...props}>
      {(node) => (
        <WrapTabNode
          key={node.key}
          index={node.key}
          moveTabNode={this.moveTabNode}
        >
          {node}
        </WrapTabNode>
      )}
    </DefaultTabBar>
  );

  render() {
    const { order } = this.state;
    const { children } = this.props;

    const tabs = [];
    React.Children.forEach(children, (c) => {
      tabs.push(c);
    });

    const orderTabs = tabs.slice().sort((a, b) => {
      const orderA = order.indexOf(a.key);
      const orderB = order.indexOf(b.key);

      if (orderA !== -1 && orderB !== -1) {
        return orderA - orderB;
      }
      if (orderA !== -1) {
        return -1;
      }
      if (orderB !== -1) {
        return 1;
      }

      const ia = tabs.indexOf(a);
      const ib = tabs.indexOf(b);

      return ia - ib;
    });

    return (
      <DragDropContextProvider backend={HTML5Backend}>
        <Tabs
          tabPosition={"bottom"}
          renderTabBar={this.renderTabBar}
          {...this.props}
        >
          {orderTabs}
        </Tabs>
      </DragDropContextProvider>
    );
  }
}
const initialState = {
  floors: [],
  discountPopUp: false,
  newOrderPopup: false,
  cancelSaleOrderList: [],
  cancelSaleITEMSList: [],
  isDiscount: false,
  isDiscountP: false,
  cancelItemsodal: false,
  cancelOrdersModal: false,
  tablesLoading: false,
  disAmt: 0,
  disPrctg: 0,
  tables: [],
  deliveryPopUp: false,
  deliveryPersopns: [],
  selectedCustomer: "",
  selectedDeliveryPerson: "",
  pos: false,
  activeKey: [{ title: "POS", key: "1", closable: false }][0].key,
  panes: [{ title: "POS", key: "1", closable: false }],
  cashupList: [],
  bookedTableData: [],
  cashUpObject: {},
  modaltype: "",
  orderCOmpleteModal: false,
  changeAmountOnOrderComplete: 0,
  modaltitle: "",
  extraNotesInput: "",
  nofGuests: "",
  avaiableTables: [],
  orderSearchVisible: false,
  releaseTable: false,
  onlineOrdersListOpens: false,
  selectOrderTypeModal: false,
  table_id_for_order_creation: null,
  searchOrderList: [],
  customerList: [],
  order_status: [],
  order_type: [],
  branchsList: [],
  warehousesList: [],
  paymentMethodsList: [],
  sortTablesBy: "1-9",
  orderId: "",
  orderStatus: "",
  printer_models: [],
  onlineOrderShow: false,
  onlineOrderData: {},
  posProductsList: [],
  no_of_online_orders: "",
  noOfDraftsOrder: "",
  online_orders_list: [],
  online_orders_listShow: false,
  draftSaleOrderList: [],
  saleOrderData: {},
  createSaleOrderInProgress: false,
  tableSize: localStorage.getItem("tableSize") || 150,
  sendToKitchenBtn: false,
  changeToDineIN: false,
  tableschangeToDineIN: [],
  floorIdchangeToDineIN: "",
  tableIdchangeToDineIN: "",
  noOfGuestchangeToDineIN: 0,
  order_type: [],
  payment: false,
  paymentBtnShow: false,
  splitOrderVisible: false,
  refundOrderModal: false,
  injazSplitOrderLineRestModel: { lines: [] },
  flrTablesListByClient: [],
  loadingRefundOrder: false,
  modalOpen: false,
  show: true,
  changecashflow: localStorage.getItem("cashClose") == "true" ? true : false,
  // rerendercount: 0
  userlockscreen: localStorage.getItem("userlock"),
  userpassword: "",
  tablesend: "",
  delcustomer: "",
  userdataobj: "",
  current_table: "",
  toggleNavPhone: false,
  colorLocation: "",
  fontLocation: "",
  loadingCreateOrderAPI: { id: "", loading: false },
  menuSetting: false,
  branchDetails: {},
};
class PosContainer extends React.Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 0;
    this.state = initialState;
    this.myRef = React.createRef();
    this.functionsecRef = React.createRef();
  }
  cosleAllPopup = () => {
    this.setState({
      modalOpen: false,
      releaseTable: false,
      selectOrderTypeModal: false,
      orderSearchVisible: false,
      online_orders_listShow: false,
      onlineOrdersListOpens: false,
      discountPopUp: false,
      splitOrderVisible: false,
      newOrderPopup: false,
    });
  };
  handlechangeColorLocation = (e) => {
    this.setState({ colorLocation: e.target.id });
    document.body.className = this.state.fontLocation + " " + e.target.id;
    localStorage.setItem(
      "themelocation",
      this.state.fontLocation + " " + e.target.id,
    );
  };
  handlechangeFontLocation = (e) => {
    this.setState({ fontLocation: e.target.id });
    document.body.className = this.state.colorLocation + " " + e.target.id;
    localStorage.setItem(
      "themelocation",
      this.state.colorLocation + " " + e.target.id,
    );
  };
  handlechangeFntSizeLocation = (e) => {
    const fontSize = e.target.value;
    localStorage.setItem("fontSize", fontSize);
    this.applyFontSize(fontSize);
  };

  applyFontSize = (size) => {
    document.body.style.fontSize = size + "px";
    document.querySelectorAll("body *").forEach((item) => {
      item.style.fontSize = size + "px";
    });
  };

  handlechangeTableSize = (e) => {
    const size = Number(e.target.value).toFixed(2);
    localStorage.setItem("tableSize", size);
    this.setState({ tableSize: size });
  };
  handleResteOptionslocation = (e) => {
    [...document.querySelectorAll("body *")].forEach((item) => {
      item.style.fontSize = "16px";
    });
    localStorage.removeItem("fontSize");
    document.querySelector(".controleFontsize").value = 16;
    document.body.className = "";
    document.querySelectorAll(".tableDiv, .tableDiv2").forEach((item) => {
      item.style.maxWidth = "150px";
      item.style.height = "150px";
    });
    setTimeout(() => window.location.reload(), 100);
  };
  handleUpdate = (newtable) => {
    this.setState({ userdataobj: newtable });
  };

  deletuser = (tablename) => {
    localStorage.removeItem(`${this.state.current_table}`);
    // console.log(this.state.userdataobj, 'from function')
  };
  async componentWillMount() {
    let posStorage = {
      pos: false,
    };
    if (this.props.posStorage) {
    } else {
      await this.props.posStorageAction(posStorage);
    }
  }
  Unlock = () => {
    axios({
      url: API_URL + "auth/signin",
      method: "POST",
      data: {
        usernameOrEmail: this.username(),
        password: this.state.userpassword,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        // console.log(response);
        if (typeof response.data != "string" || typeof (response.data != {})) {
          this.setState({ userlockscreen: false });
          localStorage.setItem("userlock", "false");
        }
        this.setState({ userpassword: "" });
        document.getElementById("userpass").value = "";
      })
      .catch((err) => {
        alert("Error: Incorrect Password");
      });
  };

  componentDidMount() {
    // console.log(localStorage.getItem('cashClose'), 'cashclose')
    // console.log(localStorage.getItem('userlockscreen'), 'userlockscreen')
    // this.setState({ changecashflow: localStorage.getItem('cashClose') == 'true' ? true : false })
    // this.setState({ userlockscreen: localStorage.getItem('userlockscreen') == 'true' ? true : false })
    const savedFontSize = localStorage.getItem("fontSize");
    if (savedFontSize) {
      setTimeout(() => {
        this.applyFontSize(savedFontSize);
        const fontSizeInput = document.querySelector(".controleFontsize");
        if (fontSizeInput) {
          fontSizeInput.value = savedFontSize;
        }
      }, 1000);
    }

    this.fetchData();
    this.getFlrTablesByClient();
    this.setState({
      deliveryPersopnSelected: this.state.saleOrderData.deliveryPerson,
    });
    this.getcancelOrders();
    this.getcancelItems();

    this.getBranchbyIdData(
      JSON.parse(localStorage.getItem("userData")).branchId,
    )
      .then((branchRes) => {
        this.setState({
          branchDetails: branchRes,
        });
      })
      .catch(() => {});
  }
  getcancelOrders = () => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    axios({
      url: API_URL + "cancelSaleOrderList",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        clientId,
        lang,
      },
    })
      .then((result) => {
        this.setState({ cancelSaleOrderList: result.data });
      })
      .catch((err) => {});
  };
  getcancelItems = () => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    axios({
      url: API_URL + "cancelSaleOrderLinesListByClient",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        clientId,
        lang,
      },
    })
      .then((result) => {
        this.setState({ cancelSaleITEMSList: result.data });
      })
      .catch((err) => {});
  };
  fetchData = () => {
    this.getBranchData();
    this.getDeliveryPersions();
    this.saleOrderByID();
    this.getDraftsOrderList();
    this.getOnlineOrders();
    this.getOrderTypes();
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    // const url =
    //   WEBSOCKET_API + JSON.parse(localStorage.getItem("userData")).branchId;
    // const ws = new WebSocket(url);
    // ws.onmessage = (res) => {
    //   this.openNotification(JSON.parse(res.data.split("order :")[1]));
    //   this.getOnlineOrders();
    //   var x = document.getElementById("myAudio");
    //   x.play();
    // };
    const branchId = JSON.parse(localStorage.getItem("userData")).branchId;

    const socket = new SockJS(WEBSOCKET_API);

    this.stompClient = Stomp.over(socket);

    this.stompClient.debug = null;

    this.stompClient.connect(
      {},
      () => {
        console.log("Socket connected");

        this.subscription = this.stompClient.subscribe(
          "/topic/app/notification/" + branchId,
          (payload) => {
            try {
              const data = JSON.parse(payload.body);
              console.log(data);

              this.openNotification(data);

              this.getOnlineOrders();

              const audio = document.getElementById("myAudio");

              if (audio) {
                audio.play().catch(() => {});
              }
            } catch (e) {
              console.error("Socket parse error", e);
            }
          },
        );
      },
      (err) => {
        console.error("Socket connection failed", err);
      },
    );
    this.onComponentDidMountRender();
    axios({
      url: API_URL + "posProductsList",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        clientId,
        lang,
      },
    })
      .then((result) => {
        this.setState({ posProductsList: result.data });
      })
      .catch((err) => {});
  };
  getDeliveryPersions = () => {
    let authOptions = {
      url: API_URL + "deliveryPersonsList",
      method: "GET",
      params: {
        clientId: localStorage.getItem("clientId"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(authOptions)
      .then((res) => {
        this.setState({ deliveryPersopns: res.data });
      })
      .catch((err) => {});
  };
  deliveryPersopnSelected = (v) => {
    this.setState({
      selectedDeliveryPerson: v,
      deliveryPopUp: false,
      selectOrderTypeModal: false,
    });
    this.createOrderonSelectOrderTypeHandler("HD");
  };
  getOrderTypes = () => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let self = this;
    axios({
      method: "GET",
      url: API_URL + "parametersListByParaType",
      params: {
        paraType: "ORDER_TYPE",
        lang: lang,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then(function(response) {
        self.setState({
          order_type: response.data,
        });
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
  };
  getBranchData = () => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    axios({
      url: API_URL + "branchByID",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        id: JSON.parse(localStorage.getItem("userData")).branchId,
        lang,
      },
    }).then((branch) => {
      if (branch.data.success) {
        localStorage.setItem("branch_data", JSON.stringify(branch.data.object));
        this.setState({ isShowKitchen: !branch.data.object.isPrntKitPayComp });
      }
    });
  };
  getUpdateAboutCustomer = () => {
    this.setState({ check: true });
  };
  getFlrTablesByClient = () => {
    axios({
      url: API_URL + "flrTablesListByClient",
      method: "GET",
      params: { clientId: localStorage.getItem("clientId") },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.setState({ flrTablesListByClient: res.data });
    });
  };
  saleOrderByID = (isCreateOrderCallBack, reload) => {
    let orderId;
    if (isCreateOrderCallBack) {
      orderId = isCreateOrderCallBack;
    } else {
      orderId = this.props.posStorage.orderId;
    }
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let data = {
      lang: localStorage.getItem("lang"),
      id: orderId,
    };
    let authOptions = {
      url: API_URL + "saleOrderByID",
      method: "GET",
      params: data,
      headers,
    };
    axios(authOptions)
      .then((res) => {
        this.setState(
          { saleOrderData: res.data.object ? res.data.object : {} },
          () => {
            if (reload) {
              if (this.refs.child) {
                this.refs.child.saleOrderByID();
                this.refs.child.getsaleOrderLine();
              }
              if (this.refs.resetTimer) {
                this.refs.resetTimer.resetState();
              }
            }
          },
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
  resetStateOnPayment = () => {
    let initialStateTemp = initialState;
    initialState.pos = true;
    initialState.changeAmountOnOrderComplete = this.state.changeAmountOnOrderComplete;
    initialState.orderCOmpleteModal = true;
    this.setState(initialStateTemp, () => {
      this.getBranchData();
      this.saleOrderByID();
      this.getDraftsOrderList();
      this.getOnlineOrders();
      let lang = localStorage.getItem("lang");
      let accessToken = localStorage.getItem("accessToken");
      let tokenType = localStorage.getItem("tokenType");
      let clientId = localStorage.getItem("clientId");
      // const url =
      //   WEBSOCKET_API + JSON.parse(localStorage.getItem("userData")).branchId;
      // const ws = new WebSocket(url);
      // ws.onmessage = (res) => {
      //   this.openNotification(JSON.parse(res.data.split("order :")[1]));
      //   this.getOnlineOrders();
      //   var x = document.getElementById("myAudio");
      //   x.play();
      // };
      const branchId = JSON.parse(localStorage.getItem("userData")).branchId;

      const socket = new SockJS(WEBSOCKET_API);

      this.stompClient = Stomp.over(socket);

      this.stompClient.debug = null;

      this.stompClient.connect(
        {},
        () => {
          console.log("Socket connected");

          this.subscription = this.stompClient.subscribe(
            "/topic/app/notification/" + branchId,
            (payload) => {
              try {
                const data = JSON.parse(payload.body);
                console.log(data);
                this.openNotification(data);

                this.getOnlineOrders();

                const audio = document.getElementById("myAudio");

                if (audio) {
                  audio.play().catch(() => {});
                }
              } catch (e) {
                console.error("Socket parse error", e);
              }
            },
          );
        },
        (err) => {
          console.error("Socket connection failed", err);
        },
      );
      this.onComponentDidMountRender();
      axios({
        url: API_URL + "posProductsList",
        method: "GET",
        headers: {
          Authorization: tokenType + " " + accessToken,
          "Content-Type": "application/json",
        },
        params: {
          clientId,
          lang,
        },
      })
        .then((result) => {
          this.setState({ posProductsList: result.data });
        })
        .catch((err) => {
          this.setState({ posProductsList: [] });
        });
    });
  };
  getOnlineOrders = () => {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    axios({
      url: API_URL + "onlineOrdersByClient",
      method: "POST",
      data: {
        clientId: clientId,
        isView: false,
        page: "0",
        size: "100",
        sortColumn: "documentNo",
        sortOrder: "DESC",
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    }).then((responce) => {
      this.setState({
        online_orders_list: responce.data.content,
        no_of_online_orders: responce.data.totalElements,
      });
      // console.log(responce.data.totalElements)
      // console.log(responce.data.content)
    });
  };
  openNotification = (data) => {
    const key = data.message.id || data.id;
    this.getOnlineOrders();

    try {
      const audio = new Audio("/noti-sound-3.mp3");
      audio.play().catch((e) => console.log("Audio play blocked:", e));
      this.getOnlineOrders();
    } catch {}

    const btn = (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          this.shoWdetailOnlineOrder(data.message);
          notification.close(key);
        }}
      >
        {this.props.language.INJAZ_POS_POS_SCREEN.BUTTON.DETAILS}
      </Button>
    );
    notification.open({
      message: this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES
        .ONLINE_ORDER_NOTI_MESSAGE,
      description: this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES
        .ONLINE_ORDER_NOTI_DETAILS,
      btn,
      key,
      onClose: this.close,
    });
  };
  close = () => {
    // console.log(
    // 'Notification was closed. Either the close button was clicked or duration time elapsed.',
    // );
  };
  calculatorFunctionnoOfGuests = (e) => {
    let nofGuests = this.state.nofGuests;
    if (e != "b" && e != "c" && e != "e" && e != ".") {
      nofGuests = nofGuests + e.toString();
      this.setState({
        nofGuests: parseFloat(nofGuests),
      });
    } else if (
      e == "b" &&
      this.state.nofGuests != 0 &&
      this.state.nofGuests != ""
    ) {
      nofGuests = nofGuests.toString();
      if (nofGuests.length == 1) {
        nofGuests = 0;
        this.setState({
          nofGuests: parseFloat(nofGuests),
        });
      } else {
        nofGuests = nofGuests.substring(0, nofGuests.length - 1);
        this.setState({
          nofGuests: parseFloat(nofGuests),
        });
      }
    } else if (e == "c") {
      nofGuests = 0;
      this.setState({
        nofGuests: parseFloat(nofGuests),
      });
    } else if (e == ".") {
      if (this.state.nofGuests == 0) {
        nofGuests = "0.";
        this.setState({
          nofGuests: nofGuests,
        });
      } else {
        nofGuests = nofGuests + ".";
        this.setState({
          nofGuests: nofGuests,
        });
      }
    } else if (e == "e") {
      if (
        this.state.paymethods.filter(
          (item) => item.id === this.state.order.payMethod,
        ).length > 0
      ) {
        if (
          this.state.paymethods.filter(
            (item) => item.id === this.state.order.payMethod,
          )[0].name === "cash"
        ) {
          this.setState({ isnofGuestsModal: true });
        } else {
          // this.paySaleOrder()
        }
      } else {
        message.error(
          this.props.language.INJAZ_POS_POS_SCREEN.PAYMENT_SCREEN.MESSAGES
            .PAY_MTHD_NOT_SELECTED_ERR,
        );
      }
    }
  };
  changeToDineINCancel = () => {
    this.setState({ changeToDineIN: false });
  };
  changeToDineINOk = () => {
    axios({
      url: API_URL + "changeOnlineOrderToDineIn",
      method: "POST",
      data: {
        id: this.state.saleOrderData.id,
        flrTable: this.state.tableIdchangeToDineIN,
        noOfGuest: parseInt(this.state.noOfGuestchangeToDineIN),
        lang: localStorage.getItem("lang"),
        initTime: 0 - Date.now(),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        if (res.data.message) {
          message.success(res.data.message);
          this.setState({ changeToDineIN: false });
        }
      } else {
        if (res.data.message) {
          message.error(res.data.message);
        }
      }
    });
  };
  floorSelectedForchangeToDineIN = (e) => {
    axios({
      url: API_URL + "flrTablesListByFloor",
      method: "GET",
      params: { floorId: e },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.setState({
        tableschangeToDineIN: res.data.filter((i) => i.status == "A"),
        floorIdchangeToDineIN: e,
      });
    });
  };
  tablesSelectedForchangeToDineIN = (v) => {
    this.setState({ tableIdchangeToDineIN: v });
  };
  shoWdetailOnlineOrder = (data) => {
    // console.log(data)
    axios({
      url: API_URL + "onlineOrderByID",
      method: "GET",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
      params: {
        id: data.id,
        lang: localStorage.getItem("lang"),
      },
    }).then((res) => {
      // console.log('online order by id',res.data.object)
      this.setState(
        { onlineOrderShow: true, onlineOrderData: res.data.object },
        () => {
          axios({
            url: API_URL + "updateOnlineOrderView",
            method: "POST",
            headers: {
              Authorization:
                localStorage.getItem("tokenType") +
                " " +
                localStorage.getItem("accessToken"),
              "Content-Type": "application/json",
            },
            data: {
              id: data.id,
              lang: localStorage.getItem("lang"),
            },
          })
            .then((res) => {
              this.getOnlineOrders();
            })
            .catch((err) => {
              // console.log(err)
            });
        },
      );
    });
  };

  YeChal() {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let self = this;
    var authOptions = {
      method: "GET",
      url: API_URL + "floorsListByBranch",
      params: {
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };
    //console.log(authOptions)
    self = this;
    axios(authOptions)
      .then(function(response) {
        let floorId = "";
        self.setState(
          {
            floors: response.data,
          },
          () => {
            if (localStorage.getItem("selectedFloor")) {
              floorId = localStorage.getItem("selectedFloor");
              if (
                document.getElementsByClassName("ant-tabs-nav-animated")
                  .length > 0
              ) {
                if (
                  document.getElementsByClassName("ant-tabs-nav-animated")[0]
                    .children.length > 0
                ) {
                  if (
                    document.getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children.length > 0
                  ) {
                    document
                      .getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children[0].setAttribute(
                        "class",
                        "ant-tabs-tab",
                      );
                  }
                  if (
                    document.getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children.length >
                    self.state.floors.findIndex(
                      (item) =>
                        item.id == localStorage.getItem("selectedFloor"),
                    )
                  ) {
                    document
                      .getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children[
                        self.state.floors.findIndex(
                          (item) =>
                            item.id == localStorage.getItem("selectedFloor"),
                        )
                      ].setAttribute(
                        "class",
                        "ant-tabs-tab-active ant-tabs-tab",
                      );
                  }
                }
              }
            } else {
              floorId = self.state.floors.length > 0 && self.state.floors[0].id;
              localStorage.setItem("selectedFloor", floorId);
            }
            let authOptionsForTables = { ...authOptions };
            authOptionsForTables.url = API_URL + "flrTablesListByFloor";
            authOptionsForTables.params = { floorId: floorId };
            axios(authOptionsForTables)
              .then(function(response) {
                let a = [...response.data];
                let c;
                let d = [];

                a.map(
                  (item, index) => (
                    (c = Object.assign(item, {
                      i: item.id,
                      x: item.xCoordinate ? item.xCoordinate : 0,
                      y: item.yCoordinate ? item.yCoordinate : 0,
                      w: 1.5,
                      h: 2,
                    })),
                    (d[index] = c)
                  ),
                );
                self.setState(
                  {
                    tables: d.sort((a, b) => {
                      return a.name.localeCompare(b.name);
                    }),
                  },
                  async () => {
                    let authOptionss = { ...authOptions };
                    authOptionss.url = API_URL + "floorOrders";
                    authOptionss.params = {
                      floorId: floorId,
                      lang: localStorage.getItem("lang"),
                    };
                    await axios(authOptionss)
                      .then((ress) => {
                        var res = d.filter(
                          (item1) =>
                            !ress.data.some(
                              (item2) => item1.id === item2.flrTable,
                            ),
                        );

                        self.setState({
                          bookedTableData: ress.data.filter(
                            (item) =>
                              item.status == "K" ||
                              item.status == "DR" ||
                              item.status == "PP",
                          ),
                          avaiableTables: res,
                        });
                      })
                      .catch((err) => {});
                  },
                );
              })
              .catch(function(error) {
                //message.error(error.response.data.message);
              });
          },
        );
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
  }
  refreshFn = (floorId) => {
    let self = this;
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    var authOptions = {
      method: "GET",
      url: API_URL + "flrTablesListByFloor",
      params: {
        floorId: floorId,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };
    axios(authOptions)
      .then(function(response) {
        let a = [...response.data];
        let c;
        let d = [];

        a.map(
          (item, index) => (
            (c = Object.assign(item, {
              i: item.id,
              x: item.xCoordinate ? item.xCoordinate : 0,
              y: item.yCoordinate ? item.yCoordinate : 0,
              w: 1.5,
              h: 2,
            })),
            (d[index] = c)
          ),
        );
        self.setState(
          {
            tables: d.sort((a, b) => {
              return a.name.localeCompare(b.name);
            }),
          },
          async () => {
            let authOptionss = { ...authOptions };
            authOptionss.url = API_URL + "floorOrders";
            authOptionss.params = {
              floorId: floorId,
              lang: localStorage.getItem("lang"),
            };
            await axios(authOptionss)
              .then((ress) => {
                var res = d.filter(
                  (item1) =>
                    !ress.data.some((item2) => item1.id === item2.flrTable),
                );

                self.setState({
                  bookedTableData: ress.data.filter(
                    (item) =>
                      item.status == "K" ||
                      item.status == "DR" ||
                      item.status == "PP",
                  ),
                  avaiableTables: res,
                });
              })
              .catch((err) => {});
          },
        );
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
    setTimeout(() => {
      if (!self.state.pos && !self.props.posStorage.pos) {
        self.refreshFn(self.state.currentFloorId);
      }
    }, 30000);
  };
  onComponentDidMountRender() {
    if (this.props.posStorage.pos) {
      // console.log('ssss',this.state.tables)
      // console.log('ssss',this.state.bookedTableData)
      // console.log('ssss',this.state.avaiableTables)
    }
    this.setState({ showButton: true });
    this.getDeliveryPersions();

    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let self = this;
    var authOptions = {
      method: "GET",
      url: API_URL + "floorsListByBranch",
      params: {
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };
    //console.log(authOptions)
    self = this;
    axios(authOptions)
      .then(function(response) {
        let floorId = "";
        self.setState(
          {
            floors: response.data,
          },
          () => {
            if (localStorage.getItem("selectedFloor")) {
              floorId = localStorage.getItem("selectedFloor");
              if (
                document.getElementsByClassName("ant-tabs-nav-animated")
                  .length > 0
              ) {
                if (
                  document.getElementsByClassName("ant-tabs-nav-animated")[0]
                    .children.length > 0
                ) {
                  if (
                    document.getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children.length > 0
                  ) {
                    document
                      .getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children[0].setAttribute(
                        "class",
                        "ant-tabs-tab",
                      );
                  }
                  if (
                    document.getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children.length >
                    self.state.floors.findIndex(
                      (item) =>
                        item.id == localStorage.getItem("selectedFloor"),
                    )
                  ) {
                    document
                      .getElementsByClassName("ant-tabs-nav-animated")[0]
                      .children[0].children[
                        self.state.floors.findIndex(
                          (item) =>
                            item.id == localStorage.getItem("selectedFloor"),
                        )
                      ].setAttribute(
                        "class",
                        "ant-tabs-tab-active ant-tabs-tab",
                      );
                  }
                }
              }
            } else {
              floorId = self.state.floors.length > 0 && self.state.floors[0].id;
              localStorage.setItem("selectedFloor", floorId);
            }
            self.setState({ currentFloorId: floorId }, () => {
              self.refreshFn(floorId);
            });
          },
        );
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });

    axios({
      method: "GET",
      url: API_URL + "parametersListByParaType",
      params: {
        paraType: "ORDER_STATUS",
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then(function(response) {
        self.setState({
          order_status: response.data,
        });
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
    axios({
      method: "GET",
      url: API_URL + "parametersListByParaType",
      params: {
        paraType: "ORDER_TYPE",
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then(function(response) {
        self.setState({
          order_type: response.data,
        });
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
    axios({
      method: "GET",
      url: API_URL + "customerList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then((result) => {
        this.setState({ customerList: result.data });
      })
      .catch((err) => {});
    axios({
      method: "GET",
      url: API_URL + "branchsList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then((result) => {
        this.setState({ branchsList: result.data });
      })
      .catch((err) => {});
    axios({
      method: "GET",
      url: API_URL + "warehousesList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then((result) => {
        this.setState({ warehousesList: result.data });
      })
      .catch((err) => {});
    axios({
      method: "GET",
      url: API_URL + "paymentMethodsList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then((result) => {
        this.setState({ paymentMethodsList: result.data });
      })
      .catch((err) => {});
    this.cashupLists();
  }
  getSearchOrders = (orderno) => {
    axios({
      url: API_URL + "searchSaleOrders",
      method: "GET",
      params: {
        // document.getElementById('fromDate').children[0].children[0].value
        clientId: localStorage.getItem("clientId"),
        documentNo: orderno ? orderno : "",
        fromDate: document.getElementById("fromDate").children[0].children[0]
          .value,
        toDate: document.getElementById("toDate").children[0].children[0].value,
        tokenNo: this.refs.tokenNo.state.value
          ? this.refs.tokenNo.state.value
          : "",
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState({ searchOrderList: res.data });
      })
      .catch((err) => {
        // console.log(err)
      });
  };
  showConfirmOnOpenCashup = () => {
    if (JSON.parse(localStorage.getItem("userData")).isCashMgmt) {
      var aa = this;
      confirm({
        content: <p style={{ color: "var(--cr-primary)" }}>Are you sure?</p>,
        onOk() {
          axios({
            url: API_URL + "openCashup",
            method: "POST",
            data: {
              branch: JSON.parse(localStorage.getItem("userData")).branchId,
              lang: localStorage.getItem("lang"),
            },
            headers: {
              Authorization:
                localStorage.getItem("tokenType") +
                " " +
                localStorage.getItem("accessToken"),
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              // if(res.data.success){
              // message.success(res.data.message)
              // }else {
              // message.error(res.data.message)

              // }
              aa.cashupLists();
              localStorage.setItem("cashClose", true);
              aa.setState({ a: "as", changecashflow: true }, () => {
                aa.cashupLists();
              });
            })
            .catch((err) => {});
        },
        onCancel() {
          // console.log('Cancel');
        },
      });
    } else {
      message.error(
        this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.CASHUP_OPEN_ERROR,
      );
    }
  };
  closeCashup = () => {
    // if (JSON.parse(localStorage.getItem('userData')).isCashMgmt) {

    //   var aa = this
    //   confirm({
    //     content: <p>Are you sure?</p>,
    //     onOk() {

    //     },
    //     onCancel() {
    //       // console.log('Cancel');
    //     },
    //   });
    // } else {
    //   message.error(this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.CASHUP_OPEN_ERROR)

    // }

    // [Othman] /api/zatca-integration/share-missed-invoices
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let data = {
      branch: JSON.parse(localStorage.getItem("userData")).branchId,
      lang: localStorage.getItem("lang"),
    };
    let authOptions = {
      url: API_URL + "closeCashUp",
      method: "POST",
      data,
      headers,
    };
    axios(authOptions)
      .then((res) => {
        if (res.data.success) {
          let sendData = { ...res.data.object };
          let branch =
            this.state.branchsList.length > 0 &&
            this.state.branchsList.filter(
              (item) => item.id == res.data.object.cashup.branch,
            ).length > 0 &&
            this.state.branchsList.filter(
              (item) => item.id == res.data.object.cashup.branch,
            )[0].name;
          sendData.branch = branch ? branch : "";
          cashUpPrint(sendData);
          this.cashupLists();
          this.setState({
            cashUpObject: "",
            modalOpen: false,
            changecashflow: false,
          });
          localStorage.setItem("cashClose", false);
          axios({
            url: API_URL + "zatca-integration/share-missed-invoices",
            method: "POST",
            params: {
              cashupId: res.data.object.cashup.id,
            },
            headers,
          })
            .then((res) => {
              // if (res.data.success) {
              //   Swal.fire({
              //     title: res.data.message,
              //     text: res.data.object || "Invoice is shard successfully",
              //     icon: "success",
              //   });
              // } else {
              //   Swal.fire({
              //     title: "Invoice sharing failed!",
              //     text: "Failed to share the invoice. Please try again.",
              //     icon: "success",
              //   });
              // }
            })
            .catch((err) => {
              console.log("zatca-integration/share-missed-invoices", err);
            });
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {});
  };
  onCreate = (values) => {
    if (JSON.parse(localStorage.getItem("userData")).isCashMgmt) {
      var authOptions = {
        method: "POST",
        url: API_URL + "createCashupExpect",
        params: {
          cashupId: this.state.cashUpObject.id,
          cashExpectAmount: values.cash,
          cardExpectAmount: values.card,
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.success) {
            this.closeCashup();
          }
        })
        .catch((err) => {});
    } else {
      message.error(
        this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.CASHUP_OPEN_ERROR,
      );
    }
  };
  cashupLists = (v) => {
    var self = this;
    var authOptionsCashUpList = {
      method: "GET",
      url: API_URL + "cashUpPaymentTypeList",
      params: {
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(authOptionsCashUpList)
      .then((res) => {
        // console.log(res)
        this.setState({ cashupList: res.data }, () => {
          res.data && self.cashById();
        });
      })
      .catch((err) => {});
  };
  cashById = () => {
    var authOptions = {
      method: "GET",
      url: API_URL + "cashupByID",
      params: {
        id: this.state.cashupList[0].cashup,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(authOptions)
      .then((res) => {
        this.setState({ cashUpObject: res.data.object });
      })
      .catch((err) => {});
  };
  handleCancel = () => {
    this.setState({ visible: false });
  };
  handleOk = () => {
    this.setState({ visible: false });
  };
  handleCancel2 = () => {
    this.setState({ visible2: false });
  };
  handleOk2 = () => {
    this.setState({ visible2: false });
  };
  createOrderWithoutTable = async (orderType) => {
    axios({
      method: "POST",
      url: API_URL + "customersByClient",
      data: {
        lang: "EN",
        clientId: localStorage.getItem("clientId"),
        name: "walk in customer",
        page: "0",
        size: "50",
        sortColumn: "name",
        sortOrder: "DESC",
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((ress) => {
        if (ress.data.success) {
          if (ress.data.content.length < 0) {
            message.error(
              this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES
                .CUST_SETUP_ERROR,
            );
          } else {
            let data = {
              lang: localStorage.getItem("lang"),
              customer: ress.data.content[0].id,
              client: localStorage.getItem("clientId"),
              flrTable: null,
              orderType: orderType,
              priority: "",
              notes: "",
              initTime: 0 - Date.now(),
              cashier: JSON.parse(localStorage.getItem("userData")).userId,
            };
            if (this.state.selectedDeliveryPerson) {
              data.deliveryPerson = this.state.selectedDeliveryPerson;
            }
            axios({
              url: API_URL + "createSaleOrder",
              method: "POST",
              data: data,
              headers: {
                Authorization:
                  localStorage.getItem("tokenType") +
                  " " +
                  localStorage.getItem("accessToken"),
                "Content-Type": "application/json",
              },
            }).then(async (res) => {
              if (res.data.success) {
                this.setState({
                  createSaleOrderInProgress: false,
                  selectOrderTypeModal: false,
                });
                localStorage.setItem("orderId", res.data.object.id);
                let posStorage = {
                  customer: ress.data.content[0].id,
                  customerName: ress.data.content[0].name,
                  orderId: res.data.object.id,
                  floorId: null,
                  pos: true,
                };
                // await localStorage.setItem('posStorage', JSON.stringify(posStorage))
                await this.props.posStorageAction(posStorage);

                this.saleOrderByID(posStorage.orderId, true);
              } else {
                this.setState({
                  createSaleOrderInProgress: false,
                  selectOrderTypeModal: false,
                });

                // console.log(res)
                message.error(res.data.message);
              }
            });
          }
        }
      })
      .catch((err) => {
        this.setState({ createSaleOrderInProgress: false });
      });
  };
  onClickTables = async (a, b, c, table) => {
    if (JSON.stringify(b) == JSON.stringify(a.find((obj) => obj.i === b.i))) {
      this.getOrderByTable(table, c);
    } else {
      axios({
        url: API_URL + "updateFlrTable",
        method: "POST",
        data: {
          lang: localStorage.getItem("lang"),
          id: c.i,
          status: table.status,
          xCoordinate: c.x,
          yCoordinate: c.y,
          name: table.name,
          tableNo: table.tableNo,
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      })
        .then((res) => {})
        .catch((err) => {});
    }
  };

  createOrderonSelectOrderType = (orderType) => {
    if ("HD" == orderType) {
      this.setState({ deliveryPopUp: true });
    } else {
      this.createOrderonSelectOrderTypeHandler(orderType);
    }
  };
  createOrderonSelectOrderTypeHandler = (orderType) => {
    if (this.state.table_id_for_order_creation) {
      this.createOrderAPI(this.state.table_id_for_order_creation, orderType);
    } else {
      this.createOrderWithoutTable(orderType);
    }
  };
  getBranchbyIdData = (id) => {
    return new Promise((resolve, reject) => {
      let a = {
        method: "GET",
        url: API_URL + "branchByID",
        params: {
          id: id,
          lang: localStorage.getItem("lang"),
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      };
      axios(a)
        .then((res) => {
          resolve(res.data.object);
        })
        .catch((err) => reject(err));
    });
  };
  createOrderAPI = (c, orderType) => {
    localStorage.setItem("selectedTable", c.i);
    this.state.loadingCreateOrderAPI = { id: c.i, loading: true };
    let self = this;
    axios({
      method: "POST",
      url: API_URL + "customersByClient",
      data: {
        lang: "EN",
        clientId: localStorage.getItem("clientId"),
        name: "walk in customer",
        page: "0",
        size: "50",
        sortColumn: "name",
        sortOrder: "DESC",
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((ress) => {
      if (ress.data.success) {
        if (ress.data.content.length < 0) {
          message.error(
            this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.CUST_SETUP_ERROR,
          );
          this.state.loadingCreateOrderAPI = { id: "", loading: false };
        } else {
          axios({
            url: API_URL + "createSaleOrder",
            method: "POST",
            data: {
              lang: localStorage.getItem("lang"),
              customer: ress.data.content[0].id,
              client: localStorage.getItem("clientId"),
              flrTable: c.i,
              orderType: orderType,
              priority: "",
              notes: "",
              cashier: JSON.parse(localStorage.getItem("userData")).userId,
              initTime: 0 - Date.now(),
            },
            headers: {
              Authorization:
                localStorage.getItem("tokenType") +
                " " +
                localStorage.getItem("accessToken"),
              "Content-Type": "application/json",
            },
          })
            .then(async (res) => {
              if (res.data.success) {
                self.YeChal();
                // message.success(res.data.message)

                let posStorage = {
                  customer: ress.data.content[0].id,
                  customerName: ress.data.content[0].name,
                  orderId: res.data.object.id,
                  floorId: res.data.object.flrTable,
                  pos: true,
                };
                if (posStorage.orderId) {
                  // await localStorage.setItem('posStorage', JSON.stringify(posStorage))
                  await self.props.posStorageAction(posStorage);
                  self.setState(
                    {
                      pos: true,
                      selectOrderTypeModal: false,
                      table_id_for_order_creation: null,
                      createSaleOrderInProgress: false,
                    },
                    () => {
                      self.saleOrderByID(res.data.object.id, true);
                    },
                  );
                }
              } else {
                message.error(res.data.message);
              }
              this.state.loadingCreateOrderAPI = { id: "", loading: false };
            })
            .catch((err) => {
              this.state.loadingCreateOrderAPI = { id: "", loading: false };
            });
        }
      }
    });
  };
  getOrderByTable = async (table, c) => {
    if (this.state.cashUpObject.status == "O") {
      let self = this;
      let awt = [...this.state.avaiableTables];
      awt.push(table);
      this.setState({ avaiableTables: awt });
      if (table.status == "A") {
        self.createOrderAPI(c, "DI");
      } else {
        let posStorage = {
          floorId: c.i,
          pos: true,
          customer:
            this.state.bookedTableData.length > 0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i).length >
              0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i)[
              this.state.bookedTableData.filter((i) => i.flrTable == c.i)
                .length - 1
            ].customerId,
          orderId:
            this.state.bookedTableData.length > 0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i).length >
              0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i)[
              this.state.bookedTableData.filter((i) => i.flrTable == c.i)
                .length - 1
            ].orderId,
          customerName:
            this.state.bookedTableData.length > 0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i).length >
              0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i)[
              this.state.bookedTableData.filter((i) => i.flrTable == c.i)
                .length - 1
            ].customer,
        };
        if (posStorage.orderId) {
          await this.props.posStorageAction(posStorage);

          this.setState({ pos: true }, () => this.saleOrderByID());
        } else {
          this.getOrderByTable(table, c);
        }
      }
    } else {
      message.error("Cashup is not opened for the branch!");
    }
  };
  // copy of create table
  getOrderByTable = async (table, c) => {
    if (this.state.cashUpObject.status == "O") {
      let self = this;
      let awt = [...this.state.avaiableTables];
      awt.push(table);
      this.setState({ avaiableTables: awt });
      if (table.status == "A") {
        self.createOrderAPI(c, "DI");
      } else {
        let posStorage = {
          floorId: c.i,
          pos: true,
          customer:
            this.state.bookedTableData.length > 0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i).length >
              0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i)[
              this.state.bookedTableData.filter((i) => i.flrTable == c.i)
                .length - 1
            ].customerId,
          orderId:
            this.state.bookedTableData.length > 0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i).length >
              0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i)[
              this.state.bookedTableData.filter((i) => i.flrTable == c.i)
                .length - 1
            ].orderId,
          customerName:
            this.state.bookedTableData.length > 0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i).length >
              0 &&
            this.state.bookedTableData.filter((i) => i.flrTable == c.i)[
              this.state.bookedTableData.filter((i) => i.flrTable == c.i)
                .length - 1
            ].customer,
        };
        if (posStorage.orderId) {
          await this.props.posStorageAction(posStorage);

          this.setState({ pos: true }, () => this.saleOrderByID());
        } else {
          this.getOrderByTable(table, c);
        }
      }
    } else {
      message.error("Cashup is not opened for the branch!");
    }
  };
  // end copy of create tab
  tabChange = (e) => {
    this.setState({ currentFloorId: e, tablesLoading: true });
    if (document.getElementsByClassName("ant-tabs-nav-animated").length > 0) {
      if (
        document.getElementsByClassName("ant-tabs-nav-animated")[0].children
          .length > 0
      ) {
        if (
          document.getElementsByClassName("ant-tabs-nav-animated")[0]
            .children[0].children.length >
          this.state.floors.findIndex(
            (item) => item.id == localStorage.getItem("selectedFloor"),
          )
        ) {
          document
            .getElementsByClassName("ant-tabs-nav-animated")[0]
            .children[0].children[
              this.state.floors.findIndex(
                (item) => item.id == localStorage.getItem("selectedFloor"),
              )
            ].setAttribute("class", "ant-tabs-tab");
        }
      }
    }
    localStorage.setItem("selectedFloor", e);

    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let self = this;
    var authOptions = {
      method: "GET",
      url: API_URL + "flrTablesListByFloor",
      params: {
        floorId: e,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };

    self = this;
    axios(authOptions).then(function(response) {
      let a = [...response.data];
      let c;
      let d = [];
      a.map(
        (item, index) => (
          (c = Object.assign(item, {
            i: item.id,
            x: item.xCoordinate ? item.xCoordinate : 0,
            y: item.yCoordinate ? item.yCoordinate : 0,
            w: 1.5,
            h: 2,
          })),
          (d[index] = c)
        ),
      );
      self.setState(
        {
          tablesLoading: false,
          tables: d.sort((a, b) => {
            return a.name.localeCompare(b.name);
          }),
        },
        () => {
          let authOptionss = { ...authOptions };
          authOptionss.url = API_URL + "floorOrders";
          authOptionss.params = {
            floorId: e,
            lang: localStorage.getItem("lang"),
          };
          axios(authOptionss)
            .then((ress) => {
              var res = d.filter(
                (item1) =>
                  !ress.data.some((item2) => item1.id === item2.flrTable),
              );
              self.setState({
                bookedTableData: ress.data.filter(
                  (item) =>
                    item.status == "K" ||
                    item.status == "DR" ||
                    item.status == "PP",
                ),
                avaiableTables: res,
              });
            })
            .catch((err) => {});
        },
      );
    });
  };
  onChange = (activeKey) => {
    this.setState({ activeKey });
  };
  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };
  add = () => {
    const { panes } = this.state;
    const activeKey = `newTab${this.newTabIndex++}`;
    panes.push({
      title: "New Tab",
      content: "Content of new Tab",
      key: activeKey,
    });
    this.setState({ panes, activeKey });
  };
  sendToKitchenbtn = (
    param,
    paymeAmount,
    cashPaidAmount,
    cancelOrderItemId,
    isPrntKitchenOnPayment,
    tables,
    floors,
  ) => {
    let Tables_ = this.state.tables;
    let Floors_ = this.state.floors;
    this.setState({ sendToKitchenBtn: true });
    // var orderID = JSON.parse(localStorage.getItem('posStorage')).orderId
    var orderID = this.props.posStorage.orderId;
    axios({
      url: API_URL + "sendOrderToKitchen",
      method: "GET",
      params: {
        lang: localStorage.getItem("lang"),
        // id: JSON.parse(localStorage.getItem('posStorage')).orderId
        id: this.props.posStorage.orderId,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((result) => {
        axios({
          url: API_URL + "posProductNameListForAllClients",
          method: "GET",
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
          params: {
            clientId: localStorage.getItem("clientId"),
            lang: localStorage.getItem("lang"),
          },
        })
          .then((results) => {
            axios({
              url: API_URL + "getSaleOrderLinesListByOrder",
              method: "GET",
              params: {
                orderId: orderID,
              },
              headers: {
                Authorization:
                  localStorage.getItem("tokenType") +
                  " " +
                  localStorage.getItem("accessToken"),
                "Content-Type": "application/json",
              },
            })
              .then(async (res) => {
                axios({
                  url: API_URL + "posComboList",
                  method: "GET",
                  headers: {
                    Authorization:
                      localStorage.getItem("tokenType") +
                      " " +
                      localStorage.getItem("accessToken"),
                    "Content-Type": "application/json",
                  },
                  params: {
                    clientId: localStorage.getItem("clientId"),
                    lang: localStorage.getItem("lang"),
                  },
                }).then(async (combo) => {
                  axios({
                    url: API_URL + "posProductsList",
                    method: "GET",
                    headers: {
                      Authorization:
                        localStorage.getItem("tokenType") +
                        " " +
                        localStorage.getItem("accessToken"),
                      "Content-Type": "application/json",
                    },
                    params: {
                      clientId: localStorage.getItem("clientId"),
                      lang: localStorage.getItem("lang"),
                    },
                  }).then(async (posProductsList) => {
                    if (param == "kitchen") {
                      let Tables_ = tables;
                      let Floors_ = floors;
                      this.refs.child.getsaleOrderLine();
                      this.sendToKitchen();
                    }
                    if (param == "rPrint" || param == "cPrint") {
                      paymeAmount = result.data.object.totalNet;
                    }
                    // here modal

                    let orderLines = [...res.data];
                    if (param == "cancelItemInKitchen") {
                      orderLines = orderLines.filter(
                        (i) =>
                          (i.id === cancelOrderItemId ||
                            i.parentProduct === cancelOrderItemId) &&
                          i.status == "C",
                      );
                    }
                    let PaidAmount =
                      parseFloat(this.state.saleOrderData.totalNet) -
                      parseFloat(this.state.saleOrderData.paidAmt);
                    if (param == "payment") {
                      let payCash = parseFloat(result.data.object.payCash);
                      if (
                        payCash > parseFloat(this.state.saleOrderData.totalNet)
                      ) {
                        let remainingAmount = parseFloat(
                          payCash -
                            (parseFloat(this.state.saleOrderData.totalNet) -
                              parseFloat(this.state.saleOrderData.paidAmt)),
                        ).toFixed(2);
                        this.setState({
                          orderCOmpleteModal: true,
                          changeAmountOnOrderComplete: remainingAmount,
                        });
                      } else {
                        let remainingAmount = 0;
                        this.setState({
                          orderCOmpleteModal: true,
                          changeAmountOnOrderComplete: remainingAmount,
                        });
                      }
                    }

                    let dd;
                    if (this.state.saleOrderData.deliveryPerson) {
                      dd = this.state.deliveryPersopns.find(
                        (i) => i.id == this.state.saleOrderData.deliveryPerson,
                      )
                        ? this.state.deliveryPersopns.find(
                            (i) =>
                              i.id == this.state.saleOrderData.deliveryPerson,
                          ).name
                        : "";
                    } else {
                      dd = "";
                    }
                    await buildMessage(
                      orderLines,
                      result.data.object,
                      results.data,
                      Tables_,
                      +Floors_,
                      this.state.printer_models,
                      param,
                      paymeAmount,
                      this.state.customerList,
                      PaidAmount,
                      combo.data,
                      posProductsList.data,
                      this.props.posStorageAction,
                      isPrntKitchenOnPayment,
                      dd,
                    );

                    if (param == "payment") {
                      this.setState({
                        orderStatus: "",
                        pos: false,
                        saleOrderData: {},
                      });
                      this.refs.child.onpaymentReset();
                    }
                    setTimeout(() => {
                      this.setState({ sendToKitchenBtn: false });
                    }, 2000);
                  });
                });
              })
              .catch((err) => {
                setTimeout(() => {
                  this.setState({ sendToKitchenBtn: false });
                }, 2000);
                // console.log(err)
              });
          })
          .catch((err) => {
            setTimeout(() => {
              this.setState({ sendToKitchenBtn: false });
            }, 2000);

            // console.log(err)
          });
      })
      .catch((err) => {
        // console.log(err)
        setTimeout(() => {
          this.setState({ sendToKitchenBtn: false });
        }, 2000);
      });
  };
  buildMessage1 = (
    param,
    paymeAmount,
    cashPaidAmount,
    cancelOrderItemId,
    isPrntKitchenOnPayment,
  ) => {
    this.setState({ sendToKitchenBtn: true });
    // var orderID = JSON.parse(localStorage.getItem('posStorage')).orderId
    var orderID = this.props.posStorage.orderId;
    axios({
      url: API_URL + "saleOrderByID",
      method: "GET",
      params: {
        lang: localStorage.getItem("lang"),
        // id: JSON.parse(localStorage.getItem('posStorage')).orderId
        id: this.props.posStorage.orderId,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((result) => {
        axios({
          url: API_URL + "posProductNameList",
          method: "GET",
          headers: {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
          params: {
            clientId: localStorage.getItem("clientId"),
            lang: localStorage.getItem("lang"),
          },
        })
          .then((results) => {
            axios({
              url: API_URL + "getSaleOrderLinesListByOrder",
              method: "GET",
              params: {
                orderId: orderID,
              },
              headers: {
                Authorization:
                  localStorage.getItem("tokenType") +
                  " " +
                  localStorage.getItem("accessToken"),
                "Content-Type": "application/json",
              },
            })
              .then(async (res) => {
                axios({
                  url: API_URL + "posComboList",
                  method: "GET",
                  headers: {
                    Authorization:
                      localStorage.getItem("tokenType") +
                      " " +
                      localStorage.getItem("accessToken"),
                    "Content-Type": "application/json",
                  },
                  params: {
                    clientId: localStorage.getItem("clientId"),
                    lang: localStorage.getItem("lang"),
                  },
                }).then(async (combo) => {
                  axios({
                    url: API_URL + "posProductsList",
                    method: "GET",
                    headers: {
                      Authorization:
                        localStorage.getItem("tokenType") +
                        " " +
                        localStorage.getItem("accessToken"),
                      "Content-Type": "application/json",
                    },
                    params: {
                      clientId: localStorage.getItem("clientId"),
                      lang: localStorage.getItem("lang"),
                    },
                  }).then(async (posProductsList) => {
                    if (param == "kitchen") {
                      this.refs.child.getsaleOrderLine();
                      this.sendToKitchen();
                    }
                    if (
                      param == "rPrint" ||
                      param == "cPrint" ||
                      param == "cDuplicate"
                    ) {
                      paymeAmount = result.data.object.totalNet;
                    }

                    // [Othman handel funcation print dublicate]
                    if (param == "printDuplicateOrderReceipt") {
                      console.log("print invoice dublicate by othman");
                    }
                    // here modal

                    let orderLines = [...res.data];

                    if (param == "cancelItemInKitchen") {
                      orderLines = orderLines.filter(
                        (i) =>
                          (i.id === cancelOrderItemId ||
                            i.parentProduct === cancelOrderItemId) &&
                          i.status == "C",
                      );
                    }

                    let PaidAmount =
                      parseFloat(this.state.saleOrderData.totalNet) -
                      parseFloat(this.state.saleOrderData.paidAmt);
                    if (param == "payment") {
                      let payCash = parseFloat(result.data.object.payCash);
                      if (
                        payCash > parseFloat(this.state.saleOrderData.totalNet)
                      ) {
                        let remainingAmount = parseFloat(
                          payCash -
                            (parseFloat(this.state.saleOrderData.totalNet) -
                              parseFloat(this.state.saleOrderData.paidAmt)),
                        ).toFixed(2);
                        this.setState({
                          orderCOmpleteModal: true,
                          changeAmountOnOrderComplete: remainingAmount,
                        });
                      } else {
                        let remainingAmount = 0;
                        this.setState({
                          orderCOmpleteModal: true,
                          changeAmountOnOrderComplete: remainingAmount,
                        });
                      }
                    }

                    let dd;
                    if (this.state.saleOrderData.deliveryPerson) {
                      dd = this.state.deliveryPersopns.find(
                        (i) => i.id == this.state.saleOrderData.deliveryPerson,
                      )
                        ? this.state.deliveryPersopns.find(
                            (i) =>
                              i.id == this.state.saleOrderData.deliveryPerson,
                          ).name
                        : "";
                    } else {
                      dd = "";
                    }

                    await buildMessage(
                      orderLines,
                      result.data.object,
                      results.data,
                      this.state.tables,
                      this.state.floors,
                      this.state.printer_models,
                      param,
                      paymeAmount,
                      this.state.customerList,
                      PaidAmount,
                      combo.data,
                      posProductsList.data,
                      this.props.posStorageAction,
                      isPrntKitchenOnPayment,
                      dd,
                      () => {
                        if (param == "payment") {
                          this.setState({ orderCOmpleteModal: false });
                          this.props.posStorageAction({ pos: false });
                          this.setState({ pos: false }, () => {
                            this.onComponentDidMountRender();
                          });
                        }
                      },
                    );

                    if (param == "payment") {
                      this.setState({
                        orderStatus: "",
                        pos: false,
                        saleOrderData: {},
                      });
                      this.refs.child.onpaymentReset();
                    }
                    this.setState({ sendToKitchenBtn: false });
                  });
                });
              })
              .catch((err) => {
                this.setState({ sendToKitchenBtn: false });

                // console.log(err)
              });
          })
          .catch((err) => {
            this.setState({ sendToKitchenBtn: false });

            // console.log(err)
          });
      })
      .catch((err) => {
        // console.log(err)
        this.setState({ sendToKitchenBtn: false });
      });
  };
  sendToKitchen = () => {
    var authOptions = {
      method: "POST",
      url: API_URL + "sendOrderToKitchen",
      data: {
        lang: localStorage.getItem("lang"),
        // id: JSON.parse(localStorage.getItem('posStorage')).orderId
        id: this.props.posStorage.orderId,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(authOptions).then((res) => {
      if (res.data.success) {
        // this.componentRef.dataFecth()
        this.setState({ sendToKitchenBtn: false });

        this.refs.child.getsaleOrderLine();
        message.success(res.data.message);
      } else {
        this.setState({ sendToKitchenBtn: false });

        message.error(res.data.message);
      }
    });
  };
  remove = (targetKey) => {
    let { activeKey } = this.state;
    let lastIndex;
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = this.state.panes.filter((pane) => pane.key !== targetKey);
    if (panes.length && activeKey === targetKey) {
      if (lastIndex >= 0) {
        activeKey = panes[lastIndex].key;
      } else {
        activeKey = panes[0].key;
      }
    }
    this.setState({ panes, activeKey });
  };
  // /paymentsssssss
  paymentScreen = (dataget) => {
    if (JSON.parse(localStorage.getItem("userData")).isCashMgmt) {
      this.setState({ showButton: false, payment: true });
      this.refs.child.onPaymentSelect();
      // localStorage.removeItem(`${dataget}`)
    } else {
      message.error(
        this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.PAY_RESTICTION_ERROR,
      );
    }
  };
  modalOpen = (a) => {
    this.refs.child.showAlert(a);
  };
  selectCustomer = () => {
    this.refs.child.customerSelect();
    this.setState({ showButton: false });
  };
  initiateSaleOrderReturn = () => {
    this.setState({
      refundOrderModal: true,
    });
    return;
    let a = {
      url: `${API_URL}initRefund`,
      method: "POST",
      data: {
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(a)
      .then((res) => {
        if (res.data.success) {
          this.setState({ orderStatus: "RI" });

          this.refs.child.saleOrderByID();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {});
  };
  getDraftsOrderList = () => {
    return new Promise((resolve, reject) => {
      axios({
        url: API_URL + "draftSaleOrderList",
        method: "GET",
        params: {
          clientId: localStorage.getItem("clientId"),
          lang: "EN",
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          this.setState({
            draftSaleOrderList: res.data,
            searchOrderList: [],
            noOfDraftsOrder: res.data.length,
          });
          // this.setState({orderSearchVisible:true})
          resolve();
        })
        .catch((err) => {
          reject();
        });
    });
  };
  completeSaleOrderReturnCancel = () => {
    this.setState({
      refundOrderModal: false,
    });
  };
  callrefundUpdateApiLine = async (i, j) => {
    return new Promise((resolve, reject) => {
      let data = {
        lang: localStorage.getItem("lang"),
        id: this.state.injazSplitOrderLineRestModel.lines[i].orderLineId,
        refundQty: parseInt(
          this.state.injazSplitOrderLineRestModel.lines[i].additionals[j]
            .splitQty,
        ),
        cashier: JSON.parse(localStorage.getItem("userData")).userId,
      };
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      let authOptions = {
        url: API_URL + "updateSaleOrderLinetRefundQty",
        method: "POST",
        data,
        headers,
      };
      axios(authOptions).then((res) => {
        // console.log(res)
        resolve();
        if (res.data.success) {
          // message.success(res.data.message);
          // this.props.getsaleOrderLine();
          // this.setState({ refunModal: false });
        } else {
          message.error(res.data.message);
        }
      });
    });
  };
  callrefundUpdateApi = async (i) => {
    return new Promise((resolve, reject) => {
      try {
        let data = {
          lang: localStorage.getItem("lang"),
          id: this.state.injazSplitOrderLineRestModel.lines[i].orderLineId,
          refundQty: parseInt(
            this.state.injazSplitOrderLineRestModel.lines[i].splitQty,
          ),
          cashier: JSON.parse(localStorage.getItem("userData")).userId,
        };
        let headers = {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        };
        let authOptions = {
          url: API_URL + "updateSaleOrderLinetRefundQty",
          method: "POST",
          data,
          headers,
        };
        axios(authOptions).then(async (res) => {
          // console.log(res)
          if (res.data.success) {
            // adtional
            if (
              this.state.injazSplitOrderLineRestModel.lines[i].additionals &&
              this.state.injazSplitOrderLineRestModel.lines[i].additionals
                .length > 0
            ) {
              for (
                let j = 0;
                j <
                this.state.injazSplitOrderLineRestModel.lines[i].additionals
                  .length;
                j++
              ) {
                await this.callrefundUpdateApiLine(i, j);
              }
              resolve();
            } else {
              resolve();
            }
          } else {
            message.error(res.data.message);
          }
        });
      } catch (e) {
        console.log(e);
      }
    });
  };
  allProductsUpdatedWithQuatity = async () => {
    return new Promise(async (resolve, reject) => {
      for (
        let i = 0;
        i < this.state.injazSplitOrderLineRestModel.lines.length;
        i++
      ) {
        await this.callrefundUpdateApi(i);
      }
      console.log("return...... 444444444444");

      resolve();
    });
  };
  completeRefnd = () => {
    let a = {
      url: `${API_URL}completeRefundOrder`,
      method: "POST",
      data: {
        // id: JSON.parse(localStorage.getItem('posStorage')).orderId,
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(a)
      .then((res) => {
        if (res.data.success) {
          this.completeSaleOrderReturnCancel();
          this.buildMessage1("refund");
          message.success(res.data.message);
          ///////////// REFUNDORDER
          this.setState({ orderStatus: "R" });
          this.refs.child.saleOrderByID();
          this.refs.child.getsaleOrderLine();
        } else {
          message.error(res.data.message);
        }
        this.setState({ orderStatus: "RI" });
        this.refs.child.saleOrderByID();
      })
      .catch((err) => {});
  };
  completeSaleOrderReturn = () => {
    this.setState({ loadingRefundOrder: true });
    let a1 = {
      url: `${API_URL}initRefund`,
      method: "POST",
      data: {
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(a1)
      .then((res) => {
        if (res.data.success) {
          setTimeout(() => {
            this.allProductsUpdatedWithQuatity().then((res) => {
              let a = {
                url: `${API_URL}completeRefundOrder`,
                method: "POST",
                data: {
                  // id: JSON.parse(localStorage.getItem('posStorage')).orderId,
                  id: this.props.posStorage.orderId,
                  lang: localStorage.getItem("lang"),
                },
                headers: {
                  Authorization:
                    localStorage.getItem("tokenType") +
                    " " +
                    localStorage.getItem("accessToken"),
                  "Content-Type": "application/json",
                },
              };
              axios(a)
                .then((res) => {
                  if (res.data.success) {
                    this.completeSaleOrderReturnCancel();
                    this.buildMessage1("refund");
                    message.success(res.data.message);
                    ///////////// REFUNDORDER
                    this.setState({ orderStatus: "R" });
                    this.refs.child.saleOrderByID();
                    this.refs.child.getsaleOrderLine();
                  } else {
                    message.error(res.data.message);
                  }
                  this.setState({ orderStatus: "RI" });
                  this.refs.child.saleOrderByID();
                })
                .catch((err) => {});
            });
          }, 500);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {})
      .finally(() => {
        this.setState({ loadingRefundOrder: false });
      });
  };
  rendercomp = () => {
    window.location.reload();
  };
  updateOrder = (e) => {
    axios({
      method: "GET",
      url: API_URL + "saleOrderByID",
      params: {
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        let parameter;
        let url;
        if (this.state.modaltype == "chtable") {
          parameter = {
            lang: localStorage.getItem("lang"),
            orderId: res.data.object.id,
            newTableId: e,
          };
          this.rendercomp();
          url = "changeOrderFlrTable";
        } else if (this.state.modaltype == "enotes") {
          parameter = {
            lang: localStorage.getItem("lang"),
            id: res.data.object.id,
            customer: res.data.object.customer,
            payMethod: res.data.object.payMethod,
            warehouse: res.data.object.warehouse,
            flrTable: res.data.object.flrTable,
            priority: res.data.object.priority,
            notes: res.data.object.notes,
            orderType: res.data.object.orderType,
            extraNotes: this.state.extraNotesInput,
            noOfGuest: this.state.noOfGuest,
            cashier: JSON.parse(localStorage.getItem("userData")).userId,
          };
          url = "updateSaleOrder";
        } else if (this.state.modaltype == "guests") {
          parameter = {
            lang: localStorage.getItem("lang"),
            id: res.data.object.id,
            customer: res.data.object.customer,
            payMethod: res.data.object.payMethod,
            warehouse: res.data.object.warehouse,
            flrTable: res.data.object.flrTable,
            priority: res.data.object.priority,
            notes: res.data.object.notes,
            extraNotes: res.data.object.extraNotes,
            orderType: res.data.object.orderType,
            noOfGuest: this.state.nofGuests,
            cashier: JSON.parse(localStorage.getItem("userData")).userId,
          };
          url = "updateSaleOrder";
        } else if (this.state.modaltype == "orderType") {
          parameter = {
            lang: localStorage.getItem("lang"),
            id: res.data.object.id,
            customer: res.data.object.customer,
            payMethod: res.data.object.payMethod,
            warehouse: res.data.object.warehouse,
            flrTable: res.data.object.flrTable,
            priority: res.data.object.priority,
            notes: res.data.object.notes,
            extraNotes: res.data.object.extraNotes,
            noOfGuest: res.data.object.noOfGuest,
            orderType: e,
            cashier: JSON.parse(localStorage.getItem("userData")).userId,
          };
          url = "updateSaleOrder";
        } else {
          parameter = "";
          url = "";
        }

        parameter != "" &&
          axios({
            url: API_URL + url,
            method: "POST",
            data: parameter,
            headers: {
              Authorization:
                localStorage.getItem("tokenType") +
                " " +
                localStorage.getItem("accessToken"),
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              if (res.data.success) {
                this.setState({ visible2: false }, () => {
                  this.refs.child.saleOrderByID();
                  message.success(res.data.message);
                });
              } else {
                message.error(res.data.message);
              }
            })
            .catch((err) => {});
      })
      .catch((err) => {});
  };
  orderSearchVisibleCancel = () => {
    this.setState({ orderSearchVisible: false });
  };
  releaseTableCancel = () => {
    this.setState({ releaseTable: false });
  };
  changeSplitQty = (v, item) => {
    if (v <= item.qty && v >= 1) {
      let injazSplitOrderLineRestModel = {
        ...this.state.injazSplitOrderLineRestModel,
      };
      if (item.isAddProduct || item.isGroupItem) {
        injazSplitOrderLineRestModel.lines
          .filter((i) => i.orderLineId == item.parentProduct)[0]
          .additionals.filter((i) => i.orderLineId == item.id)[0].splitQty = v;
        this.setState({ injazSplitOrderLineRestModel });
      } else {
        injazSplitOrderLineRestModel.lines.filter(
          (i) => i.orderLineId == item.id,
        )[0].splitQty = v;
        this.setState({ injazSplitOrderLineRestModel });
      }
    }
  };
  splitOrderHandleOk = () => {
    let data = {
      lines: [...this.state.injazSplitOrderLineRestModel.lines],
      orderId: this.props.posStorage.orderId,
      lang: localStorage.getItem("lang"),
    };
    axios({
      method: "POST",
      data,
      url: API_URL + "splitSaleOrder",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((resp) => {
      if (resp.data.success) {
        if (resp.data.success) {
          // here go to split order
          this.setState(
            {
              splitOrderVisible: false,
              injazSplitOrderLineRestModel: { lines: [] },
            },
            () => {
              this.refs.child.getsaleOrderLine();
            },
          );
          if (resp.data.message) {
            message.success(resp.data.message);
          }
          let headers = {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          };
          let authOptions = {
            method: "GET",
            url: API_URL + "saleOrderByID",
            params: {
              id: resp.data.object,
              lang: localStorage.getItem("lang"),
            },
            headers,
          };
          axios(authOptions)
            .then((res) => {
              if (res.data.success) {
                let name;

                name =
                  this.state.customerList.length > 0 &&
                  this.state.customerList.filter(
                    (item) => item.id == res.data.object.customer,
                  ).length > 0 &&
                  this.state.customerList.filter(
                    (item) => item.id == res.data.object.customer,
                  )[0].name;
                let posStorage = {
                  customer: res.data.object.customer,
                  customerName: name,
                  orderId: res.data.object.id,
                  floorId: res.data.object.flrTable,
                  pos: true,
                };
                this.props.posStorageAction(posStorage);
                this.props.history.push("pos");
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              }
            })
            .catch((err) => {});
        } else {
          if (resp.data.message) {
            message.success(resp.data.message);
          }
        }
      }
    });
    //this.setState({ splitOrderVisible: false })
  };
  splitOrderCancel = () => {
    this.setState({ splitOrderVisible: false });
  };
  orderLineSelect = (e, item) => {
    let injazSplitOrderLineRestModel = {
      ...this.state.injazSplitOrderLineRestModel,
    };
    if (item.isAddProduct || item.isGroupItem) {
      let obj = {
        orderLineId: item.id,
        splitQty: 1,
      };
      if (e.target.checked) {
        injazSplitOrderLineRestModel.lines
          .filter((i) => i.orderLineId == item.parentProduct)[0]
          .additionals.push(obj);
        this.setState({ injazSplitOrderLineRestModel });
      } else {
        injazSplitOrderLineRestModel.lines.filter(
          (i) => i.orderLineId == item.parentProduct,
        )[0].additionals = injazSplitOrderLineRestModel.lines
          .filter((i) => i.orderLineId == item.parentProduct)[0]
          .additionals.filter((i) => i.orderLineId != item.id);
        this.setState({ injazSplitOrderLineRestModel });
      }
    } else {
      let obj = {
        orderLineId: item.id,
        splitQty: 1,
        additionals: [],
      };
      if (e.target.checked) {
        injazSplitOrderLineRestModel.lines.push(obj);
        this.setState({ injazSplitOrderLineRestModel });
      } else {
        injazSplitOrderLineRestModel.lines = injazSplitOrderLineRestModel.lines.filter(
          (i) => i.orderLineId != item.id,
        );
        this.setState({ injazSplitOrderLineRestModel });
      }
    }
  };
  openOrderHandler = () => {
    if (this.state.cashUpObject.status == "O") {
      let name;
      name =
        this.state.customerList.length > 0 &&
        this.state.customerList.filter(
          (item) => item.id == this.state.searchOrderList[0].customer,
        ).length > 0 &&
        this.state.customerList.filter(
          (item) => item.id == this.state.searchOrderList[0].customer,
        )[0].name;
      let posStorage = {
        customer: this.state.searchOrderList[0].customer,
        customerName: name,
        orderId: this.state.searchOrderList[0].id,
        floorId: this.state.searchOrderList[0].flrTable,
        pos: true,
      };
      // localStorage.setItem('posStorage', JSON.stringify(posStorage))
      this.props.posStorageAction(posStorage);
      document.location.reload();

      this.saleOrderByID();
    } else {
      message.error("Cashup is not opened for the branch!");
    }
  };
  tableLockHandler = (isLock) => {
    let data = this.state.floors.filter(
      (item) => item.id == localStorage.getItem("selectedFloor"),
    )[0];
    data.isLock = true;
    var authOptions = {
      method: "POST",
      data,
      url: API_URL + "updateFloor",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(authOptions).then((res) => {
      if (res.data.success) {
        this.onComponentDidMountRender();
        if (isLock) {
          message.success(
            this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.TABLE_LOCK,
          );
        } else {
          message.success(
            this.props.language.INJAZ_POS_POS_SCREEN.MESSAGES.TABLE_UNLOCK,
          );
        }
      }
    });
  };

  // table wala func
  onClickTableWhenLoked = async (item) => {
    this.setState({ current_table: item.name });
    localStorage.setItem("minChargeAmount", item.minChargeAmount);
    if (this.state.floors.length > 0) {
      if (
        this.state.floors.filter(
          (floor) => floor.id === localStorage.getItem("selectedFloor"),
        ).length > 0
      ) {
        if (
          this.state.floors.filter(
            (floor) => floor.id === localStorage.getItem("selectedFloor"),
          )[0].isLock
        ) {
          this.getOrderByTable(item, { i: item.id });
          this.setState({ tablesend: item.name });
        }
      }
    }
  };

  handleLogout() {
    let newObj = { ...JSON.parse(localStorage.getItem("persist:root")) };
    newObj.user = {};
    newObj.clientById = {};
    newObj.parametersListByParaType = {};
    localStorage.clear();
    try {
      clear();
    } catch {}
    this.props.history.push("/");
    window.location.reload();
  }

  setuserpass = (e) => {
    this.setState({ userpassword: e.target.value });
  };

  username = () => {
    let userData = localStorage.getItem("username");
    return userData;
  };

  sortTables = (sortBy) => {
    this.setState({ sortTablesBy: sortBy });
    const sortedTables = [...this.state.tables];

    const getValue = (val) => {
      const num = Number(val);
      return isNaN(num) ? val.toString().toLowerCase() : num;
    };

    switch (sortBy) {
      case "1-9":
        sortedTables.sort((a, b) => {
          const aVal = getValue(a.tableNo);
          const bVal = getValue(b.tableNo);
          return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
        });
        break;

      case "9-1":
        sortedTables.sort((a, b) => {
          const aVal = getValue(a.tableNo);
          const bVal = getValue(b.tableNo);
          return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
        });
        break;

      case "a-z":
        sortedTables.sort((a, b) => a.name.localeCompare(b.name));
        break;

      case "z-a":
        sortedTables.sort((a, b) => b.name.localeCompare(a.name));
        break;

      default:
        break;
    }

    this.setState({ tables: sortedTables });
  };

  handleChangeLanguage = (languageToChange) => {
    Swal.fire({
      title: "تغيير اللغة",
      text: "يرجى اختيار لغتك المفضلة",
      icon: "question",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "العربية",
      denyButtonText: "English",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem("lang", "AR");
        window.location.reload();
      } else if (result.isDenied) {
        localStorage.setItem("lang", "EN");
        window.location.reload();
      }
    });
  };
  scrollLeft = () => {
    const container = this.functionsecRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollLeft - 200, // 200px كل مرة
        behavior: "smooth",
      });
    }
  };

  // التمرير لليمين
  scrollRight = () => {
    const container = this.functionsecRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollLeft + 200,
        behavior: "smooth",
      });
    }
  };

  render() {
    this.draftSaleOrderListColumns = [
      {
        title: "Name",
        dataIndex: "name",
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: "Cleaning",
        dataIndex: "operation",
        render: (text, record) => (
          <Button
            onClick={() => {
              axios({
                url: `${API_URL}updateFlrTableNeedToClean?tableId=${record.id}&&needToClean=${record.status}`,
                method: "GET",
                headers: {
                  Authorization:
                    localStorage.getItem("tokenType") +
                    " " +
                    localStorage.getItem("accessToken"),
                  "Content-Type": "application/json",
                },
              })
                .then((res) => {
                  if (res.data.success) {
                    this.setState({ releaseTable: false }, () => {
                      this.tabChange(record.floor);
                    });
                    message.success(res.data.message);
                  } else {
                    message.error(res.data.message);
                  }
                })
                .catch((err) => {});
            }}
            style={{
              opacity: ".5",
              display: JSON.parse(localStorage.getItem("branch_data"))
                .cleanTable
                ? ""
                : "",
            }}
            disabled={
              !JSON.parse(localStorage.getItem("branch_data")).cleanTable
            }
          >
            {record.needToClean
              ? this.lang.BUTTON.FINISH_CLEANING
              : this.lang.BUTTON.START_CLEANING}
          </Button>
        ),
      },
      {
        title: "Token No.",
        dataIndex: "tokenNo",
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {
              this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP.TABLEHEADERS
                .OPEN_POS
            }
          </span>
        ),
        dataIndex: "",
        render: (text, record) => (
          <button
            className="openPOSButton"
            onClick={async () => {
              if (this.state.cashUpObject.status == "O") {
                let posStorage = {
                  orderId: record.id,
                  pos: true,
                };
                await this.props.posStorageAction(posStorage);
                await this.saleOrderByID();
                window.location.reload();
              } else {
                message.error("Cashup is not opened for the branch!");
              }
            }}
          >
            {
              this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP.TABLEHEADERS
                .OPEN_POS
            }
          </button>
        ),
      },
    ];
    this.onlineOrdersColumns = [
      {
        title: (
          <span>
            {
              this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP.TABLEHEADERS
                .CUST_NAME
            }
          </span>
        ),
        dataIndex: "name",
        sorter: true,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {
              this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP.TABLEHEADERS
                .ORDERNO
            }
          </span>
        ),
        dataIndex: "documentNo",
        sorter: true,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {
              this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP.TABLEHEADERS
                .PAYMETHOD
            }
          </span>
        ),
        dataIndex: "payMethod",
        sorter: true,
        render: (text, record) => (
          <button className="link-button">
            {this.state.paymentMethodsList.length > 0 &&
              this.state.paymentMethodsList.filter((item) => item.id == text)
                .length > 0 &&
              this.state.paymentMethodsList.filter((item) => item.id == text)[0]
                .name}
          </button>
        ),
      },
      {
        title: (
          <span>
            {
              this.props.language.INJAZ_POS_ONLINEORDERLIST.SETUP.TABLEHEADERS
                .MDATE
            }
          </span>
        ),
        dataIndex: "orderDate",
        sorter: true,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
    ];
    this.lang = this.props.language.INJAZ_POS_POS_SCREEN;
    this.releaseTableListColumns = [
      {
        title: this.lang.BUTTON.TBLE_NAME,
        dataIndex: "name",
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: this.lang.ACTION,
        dataIndex: "operation",
        render: (text, record) => {
          const handleRlaseTable = () => {
            axios({
              url: `${API_URL}releaseFlrTable`,
              method: "POST",
              data: {
                id: record.id,
                lang: "EN",
              },
              headers: {
                Authorization:
                  localStorage.getItem("tokenType") +
                  " " +
                  localStorage.getItem("accessToken"),
                "Content-Type": "application/json",
              },
            })
              .then((res) => {
                if (res.data.success) {
                  this.setState({ releaseTable: false }, () => {
                    this.tabChange(record.floor);
                  });
                  message.success(res.data.message);
                } else {
                  message.error(res.data.message);
                }
              })
              .catch((err) => {});
          };
          const alertSwt = () => {
            if (this.state.branchDetails.refundPassword) {
              Swal.fire({
                title: "Please Enter Password",
                input: "text",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: "Submit",
                showLoaderOnConfirm: true,
              }).then((res) => {
                if (res.isConfirmed) {
                  // 1357
                  if (res.value === this.state.branchDetails.refundPassword) {
                    handleRlaseTable();
                  } else {
                    Swal.fire({
                      title: "Error Password!",
                      text: "Invalid Password!",
                      icon: "error",
                    });
                  }
                }
              });
            }
          };
          const checkTable = () => {
            const item = record;
            const orderId =
              this.state.bookedTableData.length > 0 &&
              this.state.bookedTableData.filter((i) => i.flrTable == item.i)
                .length > 0 &&
              this.state.bookedTableData.filter((i) => i.flrTable == item.i)[
                this.state.bookedTableData.filter((i) => i.flrTable == item.i)
                  .length - 1
              ].orderId;
            let authOptions = {
              url: API_URL + "saleOrderLinesByOrder",
              method: "POST",
              headers: {
                Authorization:
                  localStorage.getItem("tokenType") +
                  " " +
                  localStorage.getItem("accessToken"),
                "Content-Type": "application/json",
              },
              data: {
                lang: localStorage.getItem("lang"),
                clientId: localStorage.getItem("clientId"),
                // order: JSON.parse(localStorage.getItem('posStorage')).orderId,
                order: orderId,
                sortOrder: "ASC",
                sortColumn: "lineno",
                page: 0,
                size: 50,
              },
            };
            axios(authOptions)
              .then((res) => {
                if (
                  Boolean(
                    res.data.content[0] &&
                      res.data.content.find((e) => e.status == "K"),
                  )
                ) {
                  return alertSwt();
                } else {
                  return handleRlaseTable();
                }
              })
              .catch((err) => {
                return handleRlaseTable();
              });
          };
          return (
            <Button onClick={checkTable}>{this.lang.BUTTON.RTABLE} </Button>
          );
        },
      },
      {
        title: this.lang.CLEANING,
        dataIndex: "operation",
        render: (text, record) => (
          <Button
            onClick={() => {
              axios({
                url: `${API_URL}updateFlrTable`,
                method: "POST",
                data: {
                  id: record.id,
                  lang: "EN",
                  description: record.description,
                  name: record.name,
                  nameAr: record.nameAr,
                  tableNo: record.tableNo,
                  needToClean: record.needToClean ? false : true,
                  status: record.status,
                },
                headers: {
                  Authorization:
                    localStorage.getItem("tokenType") +
                    " " +
                    localStorage.getItem("accessToken"),
                  "Content-Type": "application/json",
                },
              })
                .then((res) => {
                  if (res.data.success) {
                    this.setState({ releaseTable: false }, () => {
                      this.tabChange(record.floor);
                    });
                    message.success(res.data.message);
                  } else {
                    message.error(res.data.message);
                  }
                })
                .catch((err) => {});
            }}
            style={{
              display: JSON.parse(localStorage.getItem("branch_data"))
                .cleanTable
                ? ""
                : "",
            }}
            disabled={
              !JSON.parse(localStorage.getItem("branch_data")).cleanTable
            }
          >
            {record.needToClean
              ? this.lang.BUTTON.FINISH_CLEANING
              : this.lang.BUTTON.START_CLEANING}
          </Button>
        ),
      },
    ];
    this.searchOrderListColumns = [
      {
        title: (
          <span>
            {this.lang.BUTTON.ORDR_NO}
            <br />
          </span>
        ),
        dataIndex: "documentNo",
        sorter: false,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {this.lang.TOKEN_NO}
            <br />
          </span>
        ),
        dataIndex: "tokenNo",
        sorter: false,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {"Table"}
            <br />
          </span>
        ),
        dataIndex: "flrTable",
        sorter: false,
        render: (text, record) => (
          <button className="link-button">
            {this.state.flrTablesListByClient.filter((i) => i.id == text)
              .length > 0 &&
              this.state.flrTablesListByClient.filter((i) => i.id == text)[0]
                .name
            //this.state.tables.filter(i => i.id == text)
            }
          </button>
        ),
      },
      {
        title: <span>{this.lang.BUTTON.CUST_NAME}</span>,
        dataIndex: "customer",
        sorter: true,
        render: (text, record) => (
          <button className="link-button">
            {this.state.customerList.length > 0 &&
              this.state.customerList.filter((item) => item.id == text).length >
                0 &&
              this.state.customerList.filter((item) => item.id == text)[0].name}
          </button>
        ),
      },
      {
        title: (
          <span>
            {this.lang.TABLEHEADERS.MDATE}
            <br />
          </span>
        ),
        dataIndex: "orderDate",
        sorter: false,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {this.lang.TABLEHEADERS.STATUS}
            <br />
          </span>
        ),
        dataIndex: "status",
        sorter: false,
        render: (text, record) => (
          <button className="link-button">
            {this.state.order_status.length > 0 &&
              this.state.order_status.filter((item) => item.paramCode == text)
                .length > 0 &&
              this.state.order_status.filter(
                (item) => item.paramCode == text,
              )[0].name}
          </button>
        ),
      },
      {
        title: (
          <span>
            {this.lang.TABLEHEADERS.TOTAL_AMNT}
            <br />
          </span>
        ),
        dataIndex: "totalNet",
        sorter: false,
        render: (text, record) => (
          <button className="link-button">{record.totalNet}</button>
        ),
      },
    ];

    // console.log(this.state.cashUpObject.status, 'this.state.cashUpObject.status')
    // console.log(this.state.cashUpObject, 'this.state.cashUpObject')

    let reRender;
    // console.log(this.state.userlockscreen, 'from state')
    // console.log(localStorage.getItem('userlock'), 'from localstorage')

    return (
      <React.Fragment>
        <div
          className="pos-nav"
          style={{
            display:
              this.state.show == true && !this.props.posStorage.pos
                ? "flex"
                : "none",
          }}
        >
          <div className="wrapper-nav customtableheader" id="customtableheader">
            <div
              style={{ direction: this.lang.INJAZ_AUTH_DIRECTION }}
              className="left"
            >
              <div
                className={`menuSetting ${
                  this.state.menuSetting ? "active" : ""
                }`}
              >
                <div
                  className="overlaySetting"
                  onClick={(e) => this.setState({ menuSetting: false })}
                ></div>

                <div className="contetn">
                  <div className="controleTheme">
                    {localStorage.getItem("darkTheme") ? (
                      localStorage.getItem("darkTheme") == "true" ? (
                        <button
                          className="link-button black-text-color"
                          onClick={() => {
                            localStorage.setItem("darkTheme", false);
                            window.location.reload();
                          }}
                          rel="noopener noreferrer"
                        >
                          <Icon
                            type="bg-colors"
                            theme="outlined"
                            className="dropdown-icon link-button black-text-color  "
                          />
                          {this.lang.LIGHT_THEME || "Light Theme"}
                        </button>
                      ) : (
                        <button
                          className="link-button black-text-color"
                          onClick={() => {
                            localStorage.setItem("darkTheme", true);
                            window.location.reload();
                          }}
                          rel="noopener noreferrer"
                        >
                          <Icon
                            type="bg-colors"
                            theme="outlined"
                            className="dropdown-icon link-button black-text-color "
                          />
                          {this.lang.DARK_THEME || "Dark Theme"}
                        </button>
                      )
                    ) : (
                      <button
                        className="link-button black-text-color"
                        onClick={() => {
                          localStorage.setItem("darkTheme", true);
                          window.location.reload();
                        }}
                        rel="noopener noreferrer"
                      >
                        <Icon
                          type="bg-colors"
                          theme="outlined"
                          className="dropdown-icon link-button black-text-color "
                        />
                        {this.lang.DARK_THEME || "Dark Theme"}
                      </button>
                    )}
                  </div>
                  <div className="logoutBtn">
                    <button
                      className="link-button black-text-color"
                      rel="noopener noreferrer"
                      onClick={this.handleChangeLanguage}
                    >
                      <Icon
                        type="global"
                        theme="outlined"
                        className="dropdown-icon link-button black-text-color"
                      />
                      {this.lang.SWITCH_LANGUAGE || "Switch Language"}
                    </button>
                  </div>
                  <div
                    className="logoutBtn"
                    onClick={this.handleLogout.bind(this)}
                  >
                    <button
                      className="link-button black-text-color"
                      rel="noopener noreferrer"
                    >
                      <Icon
                        type="logout"
                        theme="outlined"
                        className="dropdown-icon  link-button black-text-color "
                      />
                      {this.lang.LOGOUT || "Logout"}
                    </button>
                  </div>
                  <ul className="colorLocation">
                    <p>{this.lang.COLORS || "Colors"}</p>
                    <div className="list">
                      <li
                        id="red"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="yellow"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="green"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="blue"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="gray"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="move"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="classc"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="pink"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="blue2"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="blue3"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                      <li
                        id="black"
                        onClick={(e) => this.handlechangeColorLocation(e)}
                      ></li>
                    </div>
                  </ul>
                  <ul className="fontSizeLocation">
                    <p>{this.lang.FONT_SIZE || "Font Size"}</p>
                    <input
                      className="controleFontsize"
                      step={"any"}
                      defaultValue={16}
                      min={10}
                      max={20}
                      type="range"
                      onChange={(e) => this.handlechangeFntSizeLocation(e)}
                    />
                  </ul>
                  <ul className="fontSizeLocation">
                    <p>{this.lang.TABLE_SIZE || "Table Size"}</p>
                    <input
                      id="tableSizeInput"
                      className="controleFontsize"
                      step="any"
                      min={100}
                      max={300}
                      type="range"
                      value={this.state.tableSize}
                      onChange={this.handlechangeTableSize}
                    />
                    <span>{this.state.tableSize}px</span>
                  </ul>
                  <div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <button
                        style={{
                          flex: "1",
                          borderRadius: "5px",
                          color: "#fff !important",
                        }}
                        className="resteOptionslocation"
                        onClick={(e) => this.handleResteOptionslocation(e)}
                      >
                        <FaArrowRotateLeft />
                      </button>
                      <button
                        style={{
                          flex: "1",
                          borderRadius: "5px",
                          color: "#fff !important",
                        }}
                        className="closeMenuSetting"
                        onClick={(e) => this.setState({ menuSetting: false })}
                      >
                        {this.lang.CLOSE || "Close"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="btnArrowLeftFunctionsec"
              onClick={() => this.scrollLeft()}
            >
              <FaArrowLeft />
            </div>
            <div
              ref={this.functionsecRef}
              className={`functionsec ${
                this.state.toggleNavPhone ? "active" : ""
              }`}
              onWheel={(e) => {
                // e.preventDefault();
                e.currentTarget.scrollLeft += e.deltaY;
              }}
            >
              <i
                onClick={() => this.setState({ toggleNavPhone: false })}
                className="close"
              >
                <IoMdClose />
              </i>
              <div
                onClick={(e) =>
                  this.setState({
                    menuSetting: this.state.menuSetting ? false : true,
                  })
                }
                className="iconwrapper"
              >
                <p>{this.lang.SETTINGS}</p>
                <i>
                  <IoMdSettings />
                </i>
              </div>

              <Link to={"/dashboard/pos2"} className="iconwrapper">
                <p>{this.lang.MARKET || "Market"}</p>
                <i>
                  <IoArrowRedoOutline />
                </i>
              </Link>

              <div
                className="iconwrapper"
                onClick={() => {
                  try {
                    const elem = document.documentElement;
                    if (!document.fullscreenElement) {
                      elem.requestFullscreen().catch((err) => {
                        console.warn(
                          `Error attempting to enable full-screen mode: ${err.message}`,
                        );
                      });
                    } else {
                      document.exitFullscreen();
                    }
                  } catch {}
                }}
              >
                <p>{this.lang.FULL_SCREEN}</p>
                <i>
                  <BsFullscreenExit />
                </i>
              </div>
              {this.state.cashUpObject.status == "O" ? (
                <div
                  className={`iconwrapper ${
                    this.state.modalOpen ? "active" : ""
                  }`}
                  onClick={() => {
                    const tables = document.querySelectorAll(".tableDiv");
                    if (tables && tables.length) {
                      Swal.fire({
                        title: this.lang.CASH_UP_MESSAGE || "Cash up message",
                        text: `${this.lang.PLEASE_CLOSE_TABLES ||
                          "Please close or release red tables."} ${
                          tables.length
                        }`,
                        icon: "error",
                      });
                    } else {
                      this.setState({
                        modalOpen: this.state.modalOpen ? false : true,
                        releaseTable: false,
                        selectOrderTypeModal: false,
                        orderSearchVisible: false,
                        online_orders_listShow: false,
                        onlineOrdersListOpens: false,
                      });
                    }
                  }}
                >
                  <p>{this.lang.CASH_CLOSE}</p>
                  <i>
                    <BsCashStack />
                  </i>
                </div>
              ) : (
                <div
                  className="iconwrapper"
                  onClick={this.showConfirmOnOpenCashup}
                >
                  <p>{this.lang.CASH_OPEN}</p>
                  <i>
                    <BsCashStack />
                  </i>
                </div>
              )}
              {JSON.parse(localStorage.getItem("userData")).roles.includes(
                "ORDER_SEARCH",
              ) && (
                <div
                  className={`iconwrapper ${
                    this.state.orderSearchVisible ? "active" : ""
                  }`}
                  onClick={() =>
                    this.setState(
                      {
                        orderSearchVisible: this.state.orderSearchVisible
                          ? false
                          : true,
                        releaseTable: false,
                        selectOrderTypeModal: false,
                        modalOpen: false,
                        online_orders_listShow: false,
                        onlineOrdersListOpens: false,
                      },
                      () => this.getFlrTablesByClient(),
                    )
                  }
                >
                  <p>{this.lang.ORDER_SEARCH}</p>
                  <i>
                    <MdManageSearch />
                  </i>
                </div>
              )}
              <div
                className={`iconwrapper ${
                  this.state.online_orders_listShow ? "active" : ""
                }`}
                onClick={() => {
                  this.setState(
                    {
                      online_orders_listShow: this.state.online_orders_listShow
                        ? false
                        : true,
                      selectOrderTypeModal: false,
                      modalOpen: false,
                      orderSearchVisible: false,
                      onlineOrdersListOpens: false,
                      releaseTable: false,
                    },
                    () => {
                      console.log(this.state.online_orders_listShow);
                    },
                  );
                }}
              >
                <div className="countDown">
                  {this.state.no_of_online_orders}
                </div>
                <p>{this.lang.ONLINE}</p>
                <i>
                  <MdOutlineOnlinePrediction />
                </i>
              </div>

              {this.state.cashUpObject.status == "O" ? (
                <div
                  className={`iconwrapper ${
                    this.state.onlineOrdersListOpens ? "active" : ""
                  }`}
                  onClick={() =>
                    this.setState({
                      onlineOrdersListOpens: this.state.onlineOrdersListOpens
                        ? false
                        : true,
                      releaseTable: false,
                      selectOrderTypeModal: false,
                      online_orders_listShow: false,
                      modalOpen: false,
                      orderSearchVisible: false,
                    })
                  }
                >
                  <p>{this.lang.ORDER_LIST}</p>
                  <i>
                    <MdPlaylistAddCircle />
                  </i>
                </div>
              ) : null}
              {this.state.cashUpObject.status == "O" ? (
                <div
                  className={`iconwrapper ${
                    this.state.selectOrderTypeModal ? "active" : ""
                  }`}
                  onClick={() => {
                    if (
                      localStorage.getItem("orderType") == null ||
                      localStorage.getItem("orderType") == "null"
                    ) {
                      this.setState({
                        selectOrderTypeModal: this.state.selectOrderTypeModal
                          ? false
                          : true,
                        createSaleOrderInProgress: true,
                        onlineOrdersListOpens: false,
                        online_orders_listShow: false,
                        modalOpen: false,
                        orderSearchVisible: false,
                        releaseTable: false,
                      });
                    } else {
                      this.createOrderWithoutTable(
                        localStorage.getItem("orderType"),
                      );
                    }
                  }}
                >
                  <p>{this.lang.NEW}</p>
                  <i>
                    <MdFiberNew />
                  </i>
                </div>
              ) : null}
              {JSON.parse(localStorage.getItem("userData")).roles.includes(
                "RELEASE_TABLE",
              ) ? (
                <div
                  className={`iconwrapper ${
                    this.state.releaseTable ? "active" : ""
                  }`}
                  onClick={() =>
                    this.setState({
                      releaseTable: this.state.releaseTable ? false : true,
                      createSaleOrderInProgress: true,
                      onlineOrdersListOpens: false,
                      online_orders_listShow: false,
                      modalOpen: false,
                      orderSearchVisible: false,
                      selectOrderTypeModal: false,
                    })
                  }
                >
                  <p>{this.lang.RELEASE_TABLE}</p>
                  <i>
                    <BsWrenchAdjustable />
                  </i>
                </div>
              ) : (
                ""
              )}
            </div>
            <div
              className="btnArrowRightFunctionsec"
              onClick={() => this.scrollRight()}
            >
              <FaArrowRight />
            </div>
          </div>
        </div>
        {this.state.onlineOrdersListOpens && (
          <div className="wrapperPopupNav">
            <i onClick={this.cosleAllPopup} className="close">
              <IoMdClose />{" "}
            </i>
            <div style={{ width: "100%" }}>
              <OnlineOrdersList {...this.props} />
            </div>
          </div>
        )}
        {this.state.selectOrderTypeModal && (
          <div className="wrapperPopupNav">
            <i onClick={this.cosleAllPopup} className="close">
              <IoMdClose />{" "}
            </i>
            <p className="title">{this.lang.BUTTON.S_ORDR_TYPE}</p>
            <div className="order_types_boxes">
              {this.state.order_type.length > 0 &&
                this.state.order_type.map((item) => (
                  <div
                    className="order_types_single_box"
                    onClick={() => {
                      this.createOrderonSelectOrderType(item.paramCode);
                    }}
                  >
                    <p className="order_types_label">{item.name}</p>
                  </div>
                ))}
            </div>
            <div className="btns">
              <Button
                onClick={() =>
                  this.setState({
                    selectOrderTypeModal: false,
                    createSaleOrderInProgress: false,
                  })
                }
              >
                {this.lang.BUTTON.CANCEL}
              </Button>
            </div>
          </div>
        )}
        {this.state.cancelOrdersModal && (
          <Modal
            className="posOnlineOrdersLists"
            visible={this.state.cancelOrdersModal}
            title={this.lang.BUTTON.CANCEL_ORDERS_MODAL}
            onCancel={() => {
              this.setState({ cancelOrdersModal: false });
            }}
            footer={false}
          >
            <CancelOrdersList
              {...this.props}
              orders={this.state.cancelSaleOrderList}
            />
          </Modal>
        )}
        {this.state.cancelItemsodal && (
          <Modal
            className="posOnlineOrdersLists"
            visible={this.state.cancelItemsodal}
            title={this.lang.BUTTON.CANCEL_ITEMS_MODAL}
            onCancel={() => {
              this.setState({ cancelItemsodal: false });
            }}
            footer={false}
          >
            <CancelItemsList
              {...this.props}
              orders={this.state.cancelSaleITEMSList}
            />
          </Modal>
        )}
        {this.state.deliveryPopUp && (
          <Modal
            visible={this.state.deliveryPopUp}
            className="selectOrderTypeModal"
            title={"Select Delivery Person"}
            onCancel={() => this.setState({ deliveryPopUp: false })}
            footer={[
              <Button onClick={() => this.setState({ deliveryPopUp: false })}>
                {this.lang.BUTTON.CANCEL}
              </Button>,
            ]}
          >
            <div className="order_types_boxes">
              <Select
                onChange={(v) => this.deliveryPersopnSelected(v)}
                showSearch
                style={{ width: "100%" }}
                placeholder={"Delivery Persions"}
              >
                {this.state.deliveryPersopns.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Modal>
        )}
        {!this.props.posStorage.pos ? (
          <React.Fragment>
            {this.state.releaseTable && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <p className="title">{this.lang.BUTTON.RTABLE}</p>
                <Table
                  rowKey={Math.round(
                    Math.random() * 1000 + Math.random() * 1000,
                  )}
                  dataSource={this.state.tables.filter(
                    (item) => item.status != "A",
                  )}
                  columns={this.releaseTableListColumns}
                />
                <div className="btns">
                  <Button onClick={this.releaseTableCancel}>
                    {this.lang.BUTTON.CANCEL}
                  </Button>
                </div>
              </div>
            )}
            {this.state.orderSearchVisible && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <div className="title">{this.lang.BUTTON.SEARCH_ORDER}</div>
                <div className="inps">
                  <Input
                    ref="tokenNo"
                    placeholder={this.lang.TOKEN_NO}
                    onKeyUp={(e) =>
                      e.keyCode === 13 &&
                      this.getSearchOrders(this.refs.orderno.state.value)
                    }
                  />
                  <Input
                    ref="orderno"
                    placeholder={this.lang.BUTTON.ORDR_NO}
                    onKeyUp={(e) =>
                      e.keyCode === 13 &&
                      this.getSearchOrders(this.refs.orderno.state.value)
                    }
                  />
                  <DatePicker
                    id="fromDate"
                    defaultValue={moment(new Date())}
                    placeholder={this.lang.BUTTON.FROM_DATE}
                    onChange={(a) =>
                      this.getSearchOrders(this.refs.orderno.state.value)
                    }
                  />
                  <DatePicker
                    id="toDate"
                    defaultValue={moment(new Date())}
                    placeholder={this.lang.BUTTON.To_DATE}
                    onChange={(a) =>
                      this.getSearchOrders(this.refs.orderno.state.value)
                    }
                  />
                </div>
                <div className="btns">
                  <Button
                    style={{
                      backgroundColor: "#cc0000",
                      borderColor: "#cc0000",
                      marginTop: "20px",
                      color: "#fff",
                    }}
                    onClick={(a) =>
                      this.getSearchOrders(this.refs.orderno.state.value)
                    }
                  >
                    {this.lang.BUTTON.SEARCH}
                  </Button>
                </div>
                {this.state.searchOrderList.length > 0 && (
                  <>
                    <Table
                      dataSource={this.state.searchOrderList}
                      columns={this.searchOrderListColumns}
                      rowKey={Math.round(
                        Math.random() * 1000 + Math.random() * 1000,
                      )}
                      onRow={(record, rowIndex) => {
                        return {
                          onClick: (event) => {
                            if (this.state.cashUpObject.status == "O") {
                              let customerName =
                                this.state.customerList.length > 0 &&
                                this.state.customerList.filter(
                                  (item) => item.id == record.customer,
                                ).length > 0 &&
                                this.state.customerList.filter(
                                  (item) => item.id == record.customer,
                                )[0].name;
                              let posStorage = {
                                floorId: record.flrTable,
                                pos: true,
                                customer: record.customer,
                                orderId: record.id,
                                customerName: customerName,
                              };
                              this.props.posStorageAction(posStorage);
                              this.setState(
                                {
                                  pos: true,
                                  orderSearchVisible: false,
                                  searchOrderList: [],
                                },
                                () => {},
                              );
                              this.saleOrderByID();
                            } else {
                              message.error(
                                "Cashup is not opened for the branch!",
                              );
                            }
                          },
                        };
                      }}
                    />
                    <div className="btn">
                      <Button onClick={this.orderSearchVisibleCancel}>
                        {this.lang.BUTTON.CANCEL}{" "}
                      </Button>
                    </div>
                  </>
                )}
              </div>
            )}
            {this.state.online_orders_listShow && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <p className="title">{this.lang.BUTTON.ONLINE_ORDERS_MODAL}</p>
                <Table
                  style={{ marginTop: "10px" }}
                  columns={this.onlineOrdersColumns}
                  dataSource={this.state.online_orders_list}
                  rowKey="id"
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: (event) => {
                        if (!record.isView) {
                          axios({
                            url: API_URL + "updateOnlineOrderView",
                            method: "POST",
                            headers: {
                              Authorization:
                                localStorage.getItem("tokenType") +
                                " " +
                                localStorage.getItem("accessToken"),
                              "Content-Type": "application/json",
                            },
                            data: {
                              id: record.id,
                              lang: localStorage.getItem("lang"),
                            },
                          })
                            .then((res) => {
                              this.getOnlineOrders();
                            })
                            .catch((err) => {});
                        }
                        this.shoWdetailOnlineOrder(record);
                      },
                    };
                  }}
                />
              </div>
            )}
            {
              <Button
                disabled={
                  !(JSON.parse(localStorage.getItem("userData")).roles != null
                    ? JSON.parse(localStorage.getItem("userData")).roles.split(
                        ",",
                      ).length > 0 &&
                      JSON.parse(localStorage.getItem("userData"))
                        .roles.split(",")
                        .filter((a) => a === "RELEASE_TABLE").length > 0
                    : false)
                }
                className="refunOrderSearch custom bgsizebtn"
                style={{ margin: "0 10px  0 10px", display: "none" }}
                onClick={() => this.setState({ releaseTable: true })}
              >
                {this.lang.BUTTON.RTABLE}
              </Button>
            }
            {JSON.parse(localStorage.getItem("userData")).roles.split(",")
              .length > 0 &&
              JSON.parse(localStorage.getItem("userData"))
                .roles.split(",")
                .filter((a) => a === "RELEASE_TABLE").length > 0 && (
                <>
                  <Button
                    style={{
                      float: "right",
                      background: "#cc0000",
                      color: "#fff",
                      display: "none",
                    }}
                    className="refunOrderSearch custom bgsizebtn "
                    onClick={() => this.setState({ cancelOrdersModal: true })}
                  >
                    {this.lang.BUTTON.CANCEL_ORDERS}
                  </Button>
                  <Button
                    style={{
                      float: "right",
                      background: "#cc0000",
                      color: "#fff",
                      display: "none",
                    }}
                    className="refunOrderSearch custom bgsizebtn "
                    onClick={() => this.setState({ cancelItemsodal: true })}
                  >
                    {this.lang.BUTTON.CANCEL_ITEMS}
                  </Button>
                </>
              )}
            <Button
              className="refunOrderSearch custom bgsizebtn "
              style={{ display: "none" }}
              onClick={() =>
                this.setState({ orderSearchVisible: true }, () =>
                  this.getFlrTablesByClient(),
                )
              }
            >
              {this.lang.BUTTON.ORDERSEARCH}
            </Button>
            {this.state.cashUpObject.status == "O" && (
              <Button
                className="refunOrderSearch createOrder custom bgsizebtn "
                loading={this.state.createSaleOrderInProgress}
                style={{
                  margin: "0 10px  0 10px",
                  display: "none",
                }}
                onClick={() => {
                  if (
                    localStorage.getItem("orderType") == null ||
                    localStorage.getItem("orderType") == "null"
                  ) {
                    this.setState({
                      createSaleOrderInProgress: true,
                      selectOrderTypeModal: true,
                    });
                  } else {
                    this.createOrderWithoutTable(
                      localStorage.getItem("orderType"),
                    );
                  }
                }}
              >
                {this.lang.BUTTON.CREATEDIRECTORDER}
              </Button>
            )}
            {this.state.cashUpObject.status == "O" ? (
              <Button
                className="refunOrderSearch custom bgsizebtn dadadada"
                style={{
                  float: "right",
                  background: "#cc0000",
                  color: "#fff",
                  display: "none",
                }}
                onClick={() => {
                  if (
                    this.state.flrTablesListByClient.filter(
                      (i) => i.status == "B",
                    ) &&
                    this.state.flrTablesListByClient.filter(
                      (i) => i.status == "B",
                    ).length
                  ) {
                    message.error("Please release all tables.");
                  } else {
                    this.setState({ modalOpen: true });
                  }
                }}
              >
                {" "}
                {this.lang.BUTTON.CASHUPCLOSE}{" "}
              </Button>
            ) : (
              <Button
                className="refunOrderSearch custom bgsizebtn"
                style={{
                  float: "right",
                  background: "#cc0000",
                  color: "#fff",
                  display: "none",
                }}
                onClick={this.showConfirmOnOpenCashup}
              >
                {" "}
                {this.lang.BUTTON.CASHUPOPEN}{" "}
              </Button>
            )}

            {/* [Othman] disable draggableTabs */}
            <div className="tables">
              <div className="headerTables">
                <div className="taps">
                  {this.state.floors.map((btn) => (
                    <div
                      onClick={() => this.tabChange(btn.id)}
                      className={`tap ${
                        btn.id === this.state.currentFloorId ? "active" : ""
                      }`}
                      key={Math.random()}
                    >
                      {localStorage.getItem("lang") == "AR"
                        ? btn.nameAr
                        : btn.name}
                    </div>
                  ))}
                </div>
                <div className="icons">
                  <i
                    className={`${
                      this.state.sortTablesBy === "1-9" ? "active" : ""
                    }`}
                    onClick={() => this.sortTables("1-9")}
                  >
                    <FaSortNumericDown />
                  </i>
                  <i
                    className={`${
                      this.state.sortTablesBy === "9-1" ? "active" : ""
                    }`}
                    onClick={() => this.sortTables("9-1")}
                  >
                    <FaSortNumericDownAlt />
                  </i>
                  <i
                    className={`${
                      this.state.sortTablesBy === "a-z" ? "active" : ""
                    }`}
                    onClick={() => this.sortTables("a-z")}
                  >
                    <FaSortAlphaDown />
                  </i>
                  <i
                    className={`${
                      this.state.sortTablesBy === "z-a" ? "active" : ""
                    }`}
                    onClick={() => this.sortTables("z-a")}
                  >
                    <FaSortAlphaDownAlt />
                  </i>
                </div>
              </div>
              <div className="bodyTables">
                {this.state.floors.map((item, i) => (
                  <div key={item.id} className={`wrapTable wrapTable-${i + 1}`}>
                    {this.state.tablesLoading ? (
                      <p style={{ width: "100%", textAlign: "center" }}>
                        {this.lang.LOADING}
                      </p>
                    ) : (
                      this.state.tables.map((item) => (
                        <div
                          style={{
                            maxWidth: `${this.state.tableSize}px`,
                            height: `${this.state.tableSize}px`,
                            width: "100% !important",
                          }}
                          onClick={() => this.onClickTableWhenLoked(item)}
                          key={item.id}
                          value={item.id}
                          className={`
                      ${
                        item.status == "A"
                          ? "tableDiv2 custom"
                          : "tableDiv custom"
                      } ${
                            item.id === this.state.loadingCreateOrderAPI.id &&
                            this.state.loadingCreateOrderAPI.loading
                              ? "loadingTableDiv"
                              : ""
                          }`}
                        >
                          <div className="tableWrap">
                            {item.id === this.state.loadingCreateOrderAPI.id &&
                            this.state.loadingCreateOrderAPI.loading ? (
                              <div className="loadingTableDiv">
                                <div className="loader"></div>
                              </div>
                            ) : (
                              ""
                            )}
                            {item.status == "A" ? (
                              <MdTableBar size={50} color={"green"} />
                            ) : (
                              <MdTableBar size={50} color={"red"} />
                            )}
                            <p className="numb">{item.name}</p>
                            {item.needToClean ? (
                              <>
                                <img
                                  alt="card"
                                  src="/cleaning_img.jpg"
                                  style={{ width: "100%", height: "75px" }}
                                />
                              </>
                            ) : (
                              <>
                                {item.status != "A" &&
                                this.state.bookedTableData.length > 0 &&
                                this.state.bookedTableData.filter(
                                  (i) => i.flrTable == item.i,
                                ).length > 0 &&
                                this.state.bookedTableData.filter(
                                  (i) => i.flrTable == item.i,
                                )[
                                  this.state.bookedTableData.filter(
                                    (i) => i.flrTable == item.i,
                                  ).length - 1
                                ].orderNo ? (
                                  <p className="orderNo">
                                    {item.status != "A" &&
                                      this.state.bookedTableData.length > 0 &&
                                      this.state.bookedTableData.filter(
                                        (i) => i.flrTable == item.i,
                                      ).length > 0 &&
                                      this.state.bookedTableData.filter(
                                        (i) => i.flrTable == item.i,
                                      )[
                                        this.state.bookedTableData.filter(
                                          (i) => i.flrTable == item.i,
                                        ).length - 1
                                      ].orderNo}
                                  </p>
                                ) : (
                                  ""
                                )}

                                {item.status != "A" &&
                                  this.state.bookedTableData.length > 0 &&
                                  this.state.bookedTableData.filter(
                                    (i) => i.flrTable == item.i,
                                  ).length > 0 &&
                                  this.state.bookedTableData.filter(
                                    (i) => i.flrTable == item.i,
                                  )[
                                    this.state.bookedTableData.filter(
                                      (i) => i.flrTable == item.i,
                                    ).length - 1
                                  ].tokenNo && (
                                    <p className="tokenNo">
                                      {this.lang.ORDER_NO}:{" "}
                                      {
                                        this.state.bookedTableData.filter(
                                          (i) => i.flrTable == item.i,
                                        )[
                                          this.state.bookedTableData.filter(
                                            (i) => i.flrTable == item.i,
                                          ).length - 1
                                        ].tokenNo
                                      }
                                    </p>
                                  )}
                                {item.status != "A" &&
                                  this.state.bookedTableData.length > 0 &&
                                  this.state.bookedTableData.filter(
                                    (i) => i.flrTable == item.i,
                                  ).length > 0 &&
                                  this.state.bookedTableData.filter(
                                    (i) => i.flrTable == item.i,
                                  )[
                                    this.state.bookedTableData.filter(
                                      (i) => i.flrTable == item.i,
                                    ).length - 1
                                  ].orderId &&
                                  this.state.bookedTableData.filter(
                                    (i) => i.flrTable == item.i,
                                  )[
                                    this.state.bookedTableData.filter(
                                      (i) => i.flrTable == item.i,
                                    ).length - 1
                                  ].initTime && (
                                    <Timer
                                      time={
                                        this.state.bookedTableData.filter(
                                          (i) => i.flrTable == item.i,
                                        )[
                                          this.state.bookedTableData.filter(
                                            (i) => i.flrTable == item.i,
                                          ).length - 1
                                        ].initTime
                                      }
                                      classnameProps="containerTimerFloors"
                                      localStorage={
                                        "timer" +
                                        this.state.bookedTableData.filter(
                                          (i) => i.flrTable == item.i,
                                        )[
                                          this.state.bookedTableData.filter(
                                            (i) => i.flrTable == item.i,
                                          ).length - 1
                                        ].orderId
                                      }
                                      interval={1000}
                                    />
                                  )}
                              </>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div
              className="userlock"
              onClick={() => {
                this.setState({ userlockscreen: true });
                localStorage.setItem("userlock", "true");
              }}
            >
              <FaUserLock />
            </div>

            <div
              className={
                this.state.userlockscreen == true ||
                localStorage.getItem("userlock") == "true"
                  ? "showuser overlay"
                  : "hideuser overlay"
              }
            >
              <div className="inneruser">
                {/* <ImCross
                  onClick={this.Unlock}
                  className="cross"
                /> */}

                <div className="avatarbox">
                  <div
                    className="image"
                    style={{
                      background: localStorage.getItem("clientlogo")
                        ? `url(${API_URL}getProductImage?clientName=stest&imageName=${localStorage.getItem(
                            "clientlogo",
                          )}&imageContent=image/jpeg)`
                        : "white",
                    }}
                  ></div>

                  <div className="hedi">
                    <h1>{this.username()}</h1>
                  </div>

                  <div className="innerinp">
                    <input
                      placeholder="Enter Password"
                      type="password"
                      id="userpass"
                      className="inp"
                      onChange={this.setuserpass.bind(this)}
                    />
                    <button className="buttonlin" onClick={this.Unlock}>
                      Unlock Screen
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {this.state.onlineOrderShow && (
              <Modal
                visible={this.state.onlineOrderShow}
                title="Online Order"
                onCancel={() => {
                  this.setState({
                    onlineOrderShow: false,
                    onlineOrderData: {},
                  });
                }}
                footer={[
                  <Button
                    key="back"
                    style={{ background: "green !important" }}
                    onClick={() => {
                      axios({
                        url: API_URL + "acceptOnlineOrder",
                        method: "POST",
                        headers: {
                          Authorization:
                            localStorage.getItem("tokenType") +
                            " " +
                            localStorage.getItem("accessToken"),
                          "Content-Type": "application/json",
                        },
                        data: {
                          id: this.state.onlineOrderData.id,
                          lang: localStorage.getItem("lang"),
                        },
                      })
                        .then((res) => {
                          if (res.data.success) {
                            this.onComponentDidMountRender();
                            message.success(res.data.message);
                            let name;
                            name =
                              this.state.customerList.length > 0 &&
                              this.state.customerList.filter(
                                (item) =>
                                  item.id == this.state.onlineOrderData.name,
                              ).length > 0 &&
                              this.state.customerList.filter(
                                (item) =>
                                  item.id == this.state.onlineOrderData.name,
                              )[0].name;
                            let posStorage = {
                              customer: this.state.onlineOrderData.name,
                              customerName: this.state.onlineOrderData.name,
                              orderId: res.data.object,
                              floorId: this.state.onlineOrderData.flrTable,
                              pos: true,
                            };

                            this.props.posStorageAction(posStorage);
                            this.props.history.push("pos");
                            this.setState({
                              onlineOrderShow: false,
                              onlineOrderData: {},
                            });
                            window.location.reload();
                          } else {
                            message.error(res.data.message);
                          }
                        })
                        .catch((err) => {});
                    }}
                  >
                    {this.lang.BUTTON.ACCEPT}
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    style={{ background: "red !important" }}
                    onClick={() => {
                      axios({
                        url: API_URL + "rejectOnlineOrder",
                        method: "POST",
                        headers: {
                          Authorization:
                            localStorage.getItem("tokenType") +
                            " " +
                            localStorage.getItem("accessToken"),
                          "Content-Type": "application/json",
                        },
                        data: {
                          id: this.state.onlineOrderData.id,
                          lang: localStorage.getItem("lang"),
                        },
                      })
                        .then((res) => {
                          this.setState({
                            onlineOrderShow: false,
                            onlineOrderData: {},
                          });
                        })
                        .catch((err) => {});
                    }}
                  >
                    {this.lang.BUTTON.REJECT}
                  </Button>,
                ]}
              >
                <Row gutter={24}>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.ORDR_NO}>
                      {this.state.onlineOrderData.documentNo}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.CUST_NAME}>
                      {this.state.onlineOrderData.name}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.PAYMETHOD}>
                      {this.state.paymentMethodsList.length > 0 &&
                        this.state.paymentMethodsList.filter(
                          (item) =>
                            item.id == this.state.onlineOrderData.payMethod,
                        ).length > 0 &&
                        this.state.paymentMethodsList.filter(
                          (item) =>
                            item.id == this.state.onlineOrderData.payMethod,
                        )[0].name}
                    </FormItem>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.PH_NO}>
                      {this.state.onlineOrderData.phoneNo}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.ADDRESS}>
                      {this.state.onlineOrderData.address}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.TOTAL}>
                      {this.state.onlineOrderData.totalNet}
                    </FormItem>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={8}>{this.lang.BUTTON.QTY}</Col>
                  <Col span={8}>{this.lang.BUTTON.ITEM_NAME}</Col>
                  <Col span={8}>{this.lang.BUTTON.TOTAL}</Col>
                </Row>
                {this.state.onlineOrderData.lines &&
                  this.state.onlineOrderData.lines.length > 0 &&
                  this.state.onlineOrderData.lines.map((item, index) => (
                    <React.Fragment>
                      <Row
                        key={index}
                        gutter={24}
                        style={{
                          border: "1px solid #F2F3F4",
                          background: "#F2F3F4",
                          marginBottom: "3px",
                        }}
                      >
                        <Col span={8}>{item.qty}</Col>
                        <Col span={8}>
                          {this.state.posProductsList &&
                            this.state.posProductsList.length > 0 &&
                            this.state.posProductsList.filter(
                              (ii) => ii.id === item.product,
                            ).length > 0 &&
                            this.state.posProductsList.filter(
                              (ii) => ii.id === item.product,
                            )[0].name}
                        </Col>
                        <Col span={8}>{item.totalNetLine}</Col>
                      </Row>
                      {item.additionals.length > 0 &&
                        item.additionals.map((add, i) => (
                          <Row
                            key={index}
                            gutter={24}
                            style={{
                              border: "1px solid #F2F3F4",
                              background: "#F2F3F4",
                              marginBottom: "3px",
                            }}
                          >
                            <Col span={8}>{add.qty}</Col>
                            <Col span={8}>
                              {this.state.posProductsList &&
                                this.state.posProductsList.length > 0 &&
                                this.state.posProductsList.filter(
                                  (ii) => ii.id === add.product,
                                ).length > 0 &&
                                this.state.posProductsList.filter(
                                  (ii) => ii.id === add.product,
                                )[0].name}
                            </Col>
                            <Col span={8}>{add.totalNetLine}</Col>
                          </Row>
                        ))}
                    </React.Fragment>
                  ))}
              </Modal>
            )}
            {this.state.modalOpen && (
              <FormCashup
                modalOpen={this.state.modalOpen}
                onCancel={() => this.setState({ modalOpen: false })}
                onCreate={this.onCreate}
              />
            )}
          </React.Fragment>
        ) : (
          <div>
            <Row style={{ display: "none" }}>
              <Button
                className="posButtonTop custom "
                onClick={() => {
                  this.props.posStorageAction({ pos: false });
                  this.setState({ pos: false }, () => {
                    this.onComponentDidMountRender();
                  });
                }}
                style={{
                  float: "left",
                  background: "rgb(125, 74, 223)",
                  color: "rgb(255, 255, 255)",
                  padding: "2px 10px",
                }}
              >
                <img src="/table-icon.png" alt="" width="38px" height="38px" />
                {/* {Table} */}
              </Button>

              {false && (
                <Button
                  loading={this.state.createSaleOrderInProgress}
                  disable={
                    this.state.createSaleOrderInProgress
                      ? this.state.createSaleOrderInProgress
                      : false
                  }
                  className="posButtonTop custom "
                  style={{
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                  onClick={() => {
                    if (
                      localStorage.getItem("orderType") == null ||
                      localStorage.getItem("orderType") == "null"
                    ) {
                      this.setState({
                        createSaleOrderInProgress: true,
                        selectOrderTypeModal: true,
                      });
                    } else {
                      this.createOrderWithoutTable(
                        localStorage.getItem("orderType"),
                      );
                    }
                  }}
                >
                  {this.lang.BUTTON.CREATEDIRECTORDER}
                </Button>
              )}
              {JSON.parse(localStorage.getItem("userData")).roles.split(",")
                .length > 0 &&
                JSON.parse(localStorage.getItem("userData"))
                  .roles.split(",")
                  .filter((a) => a === "RELEASE_TABLE").length > 0 && (
                  <Button
                    //loading={this.state.createSaleOrderInProgress}
                    //disable={this.state.createSaleOrderInProgress ? this.state.createSaleOrderInProgress : false}
                    className="posButtonTop custom  "
                    style={{
                      float: "right",
                      background: "#cc0000",
                      color: "#fff",
                    }}
                    onClick={() => {
                      axios({
                        url: API_URL + "cancelSaleOrder",
                        method: "POST",
                        headers: {
                          Authorization:
                            localStorage.getItem("tokenType") +
                            " " +
                            localStorage.getItem("accessToken"),
                          "Content-Type": "application/json",
                        },
                        data: {
                          id: this.props.posStorage.orderId,
                          lang: localStorage.getItem("lang"),
                        },
                      }).then((res) => {
                        if (res.data.success) {
                          this.setState({ A: "a" });
                          this.saleOrderByID();
                          this.refs.child.saleOrderByID();
                          this.refs.child.getsaleOrderLine();
                          message.success(res.data.message);
                        } else {
                          message.error(res.data.message);
                        }
                      });
                    }}
                  >
                    {this.lang.BUTTON.VOID_ORDER}
                  </Button>
                )}
              <Button
                className="posButtonTop  custom"
                style={{ float: "right", background: "#cc0000", color: "#fff" }}
                onClick={() => {
                  this.setState({ splitOrderVisible: true });
                }}
              >
                {this.lang.BUTTON.SPLIT_ORDER}
              </Button>
              <Button
                className="posButtonTop  custom order-btn "
                style={{
                  float: "right",
                  background: "#faad14",
                  color: "#fff",
                  padding: "14px 16px",
                }}
                onClick={() =>
                  this.getDraftsOrderList().then(() => {
                    this.setState({ orderSearchVisible: true }, () =>
                      this.getFlrTablesByClient(),
                    );
                  })
                }
              >
                <Badge count={this.state.noOfDraftsOrder}>
                  <img
                    src="/product_search_icon.png"
                    width="24px"
                    height="24px"
                    alt=""
                  />
                </Badge>
                {
                  //this.lang.BUTTON.ORDERINFO
                }{" "}
              </Button>
              {JSON.parse(localStorage.getItem("userData"))
                .roles.split(",")
                .includes("DISCOUNT_ROLE") && (
                <Button
                  className="posButtonTop custom "
                  style={{
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                  onClick={() => this.setState({ discountPopUp: true })}
                >
                  {this.lang.BUTTON.DISCOUNT_ORDER}
                </Button>
              )}
              <Button
                className="posButtonTop custom raza"
                style={{ float: "right", background: "#cc0000", color: "#fff" }}
                onClick={() => this.setState({ onlineOrdersListOpens: true })}
              >
                {this.lang.BUTTON.ONLINEORDERS}
              </Button>
              {this.state.showButton && (
                <Button
                  className="posButtonTop custom"
                  onClick={this.paymentScreen}
                  style={{
                    display: "none",
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.PAYMENTMETHOD}
                </Button>
              )}
              {this.state.showButton && (
                <Button
                  className="posButtonTop custom"
                  onClick={() =>
                    this.setState({
                      visible: true,
                    })
                  }
                  style={{
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.OPTIONS}{" "}
                </Button>
              )}
              <Button
                onClick={() => {
                  this.setState({ online_orders_listShow: true });
                }}
                style={{ float: "right", background: "#cc0000", color: "#fff" }}
                className="posButtonTop custom notificationbtn"
              >
                <Badge count={this.state.no_of_online_orders}>
                  <img src="/noti_icon.png" width="38px" height="38px" alt="" />
                </Badge>
              </Button>
              {this.state.showButton && (
                <Button
                  className="custom posButtonTop customdata"
                  onClick={() => this.modalOpen("selectPayment")}
                  style={{
                    display: "none",
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.PAYMENTMETHOD}
                </Button>
              )}
              {this.state.showButton && (
                <Button
                  className="posButtonTop custom"
                  onClick={() => this.modalOpen("priority")}
                  style={{
                    display: "none",
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.PRIORITY}
                </Button>
              )}
              {this.state.showButton && (
                <Button
                  className="posButtonTop custom"
                  onClick={() => this.modalOpen("notes")}
                  style={{
                    display: "none",
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.NOTES}
                </Button>
              )}
              {this.state.showButton ? (
                <Button
                  className="posButtonTop custom customdata"
                  onClick={this.selectCustomer}
                  style={{
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {/* <Icon type="user" /> */}
                  {this.props.posStorage && this.props.posStorage.customerName
                    ? this.props.posStorage.customerName
                    : this.lang.BUTTON.SELECTCUSTOMER}
                </Button>
              ) : (
                false
              )}
              {this.state.saleOrderData.status == "P" ? (
                <Button
                  className="posButtonTop custom"
                  onClick={() => this.initiateSaleOrderReturn()}
                  style={{
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.REFUNDINITIATE}
                </Button>
              ) : this.state.saleOrderData.status == "RI" ? (
                <Button
                  className="posButtonTop custom"
                  onClick={() => this.completeRefnd()}
                  style={{
                    float: "right",
                    background: "#cc0000",
                    color: "#fff",
                  }}
                >
                  {this.lang.BUTTON.REFUNDCOMPLETE}
                </Button>
              ) : (
                ""
              )}
              {/* {console.log( this.state.isShowKitchen && this.props.posStorage.orderId &&
                this.refs.child &&
                this.refs.child.state.showSendToKitchenButton  )} */}
              {this.state.isShowKitchen &&
                this.props.posStorage.orderId &&
                this.refs.child &&
                this.refs.child.state.showSendToKitchenButton && (
                  <Button
                    loading={this.state.sendToKitchenBtn}
                    className="posButtonTop sendToKitchenBtn custom"
                    style={{
                      float: "right",
                      color: "#fff",
                      background: "rgb(11, 65, 133)",
                    }}
                    onClick={() =>
                      this.sendToKitchenbtn(
                        "kitchen",
                        null,
                        null,
                        null,
                        false,
                        this.state.tables,
                        this.state.floors,
                      )
                    }
                  >
                    {/* {this.lang.BUTTON.SENDTOKITCHEN} */}
                    <img
                      src="/kitchen-icon.png"
                      width="38px"
                      height="38px"
                      alt=""
                    />
                  </Button>
                )}
            </Row>
            <Row>
              <Tabs
                onChange={this.onChange}
                activeKey={this.state.activeKey}
                type="card"
                className="posTab"
                onEdit={this.onEdit}
              >
                {this.state.panes.map((pane, i) => (
                  <TabPane
                    className="posTabPan"
                    tab={[
                      <span key={i}>
                        {pane.title} {}
                      </span>,
                    ]}
                    key={pane.key}
                    closable={pane.closable}
                  >
                    <PosChildContainer
                      paymethods={this.state.paymentMethodsList}
                      paymentok={(v, cashPaidAmount) => {
                        this.buildMessage1("payment", v, cashPaidAmount);
                        this.setState({ payment: false });
                        this.getBranchbyIdData(
                          JSON.parse(localStorage.getItem("userData")).branchId,
                        ).then((res) => {
                          if (res.isPrntKitPayComp) {
                            // this.setState({
                            //   userdataobj:{}
                            // });
                            // let thatt =  this;

                            this.buildMessage1(
                              "kitchen",
                              null,
                              null,
                              null,
                              true,
                              this.state.tables,
                              this.state.floors,
                            );
                          }
                        });
                      }}
                      newOrderPopup={this.state.newOrderPopup}
                      discountPopUp={this.state.discountPopUp}
                      onlineOrdersListOpens={this.state.onlineOrdersListOpens}
                      online_orders_listShow={this.state.online_orders_listShow}
                      splitOrderVisible={this.state.splitOrderVisible}
                      isShowKitchen={this.state.isShowKitchen}
                      isDiscount={this.state.isDiscount}
                      isDiscountP={this.state.isDiscountP}
                      disAmt={this.state.disAmt}
                      disPrctg={this.state.disPrctg}
                      no_of_online_orders={this.state.no_of_online_orders}
                      saleOrderData={this.state.saleOrderData}
                      language={this.props.language}
                      showButton={this.state.showButton}
                      sendToKitchenBtn={this.state.sendToKitchenBtn}
                      selectPaymentModalOpen={() =>
                        this.modalOpen("selectPayment")
                      }
                      REFUNDINITIATE={this.lang.BUTTON.REFUNDINITIATE}
                      REFUNDINITIATEfunc={() => this.initiateSaleOrderReturn()}
                      REFUNDCOMPLETE={this.lang.BUTTON.REFUNDCOMPLETE}
                      REFUNDCOMPLETEfunc={() => this.completeRefnd()}
                      onUpdate={this.handleUpdate}
                      senPrintOnCancelOrder={(i) =>
                        this.buildMessage1("cancelItemInKitchen", null, null, i)
                      }
                      resetStateOnPayment={() => {
                        this.resetStateOnPayment();
                      }}
                      paymentScreen={(innerval) => this.paymentScreen(innerval)}
                      getUpdateAboutCustomer={() =>
                        this.getUpdateAboutCustomer()
                      }
                      saleOrderByIDFunction={(a) => {
                        this.saleOrderByID(null, a);
                      }}
                      printInKitchen={() =>
                        this.buildMessage1(
                          "kitchen",
                          null,
                          null,
                          null,
                          true,
                          this.state.tables,
                          this.state.floors,
                        )
                      }
                      buildMessage1={(param, paymeAmount, cashPaidAmount) =>
                        this.buildMessage1(param, paymeAmount, cashPaidAmount)
                      }
                      updateSatte={() => {
                        this.setState({ a: "a" });
                      }}
                      showButtos={() => {
                        this.setState({ showButton: true });
                      }}
                      props={this.props.language}
                      sendToKitchenButtonShow={() => {
                        this.setState({});
                      }}
                      showOptionModal={() => {
                        this.setState({ visible: true });
                      }}
                      ref="child"
                      lang={this.lang}
                      walkin={this.selectCustomer}
                      kitchen={() => {
                        this.buildMessage1(
                          "kitchen",
                          null,
                          null,
                          null,
                          false,
                          this.state.tables,
                          this.state.floors,
                        );
                      }}
                      onlineorderpopup={() => {
                        this.setState({
                          online_orders_listShow: this.state
                            .online_orders_listShow
                            ? false
                            : true,
                          onlineOrdersListOpens: false,
                          discountPopUp: false,
                          splitOrderVisible: false,
                          newOrderPopup: false,
                        });
                      }}
                      splitorder={() => {
                        this.setState({
                          splitOrderVisible: this.state.splitOrderVisible
                            ? false
                            : true,
                          online_orders_listShow: false,
                          onlineOrdersListOpens: false,
                          discountPopUp: false,
                          newOrderPopup: false,
                        });
                      }}
                      newOrderFuc={() => {
                        this.setState({
                          newOrderPopup: this.state.newOrderPopup
                            ? false
                            : true,
                          splitOrderVisible: false,
                          online_orders_listShow: false,
                          onlineOrdersListOpens: false,
                          discountPopUp: false,
                        });
                      }}
                      voidorder={() => {
                        axios({
                          url: API_URL + "cancelSaleOrder",
                          method: "POST",
                          headers: {
                            Authorization:
                              localStorage.getItem("tokenType") +
                              " " +
                              localStorage.getItem("accessToken"),
                            "Content-Type": "application/json",
                          },
                          data: {
                            id: this.props.posStorage.orderId,
                            lang: localStorage.getItem("lang"),
                          },
                        }).then((res) => {
                          if (res.data.success) {
                            this.setState({ A: "a" });
                            this.saleOrderByID();
                            // this.refs.child.saleOrderByID();
                            // this.refs.child.getsaleOrderLine();
                            message.success(res.data.message);
                          } else {
                            message.error(res.data.message);
                          }
                        });
                      }}
                      orderlist={() =>
                        this.setState({
                          onlineOrdersListOpens: this.state
                            .onlineOrdersListOpens
                            ? false
                            : true,
                          discountPopUp: false,
                          online_orders_listShow: false,
                          splitOrderVisible: false,
                          newOrderPopup: false,
                        })
                      }
                      discount={() =>
                        this.setState({
                          discountPopUp: this.state.discountPopUp
                            ? false
                            : true,
                          onlineOrdersListOpens: false,
                          online_orders_listShow: false,
                          splitOrderVisible: false,
                          newOrderPopup: false,
                        })
                      }
                      showheader={() => {
                        this.setState({ show: true });
                      }}
                      hideheader={() => {
                        this.setState({ show: false });
                      }}
                      releastab={() => {
                        this.setState({ releaseTable: false });
                      }}
                      posfalse={() => {
                        this.props.posStorageAction({ pos: false });
                      }}
                      onComponentDidMountRender={() => {
                        this.onComponentDidMountRender();
                      }}
                      guest={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "guests",
                          modaltitle: this.lang.BUTTON.GUEST,
                        })
                      }
                      changetab={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "chtable",
                          modaltitle: this.lang.BUTTON.CHANGETABLE,
                        })
                      }
                      ordertype={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "orderType",
                          modaltitle: this.lang.BUTTON.ORDERTYPE,
                        })
                      }
                      // [Othman add type print printDuplicateOrderReceipt]
                      print={() => {
                        this.buildMessage1("cPrint");
                      }}
                      printDuplicate={() => {
                        this.buildMessage1("cDuplicate");
                      }}
                      tablenemeprop={this.state.tablesend}
                    />
                  </TabPane>
                ))}
              </Tabs>
            </Row>
            {this.state.refundOrderModal && (
              <Modal
                visible={this.state.refundOrderModal}
                title={"Refund Order"}
                footer={[
                  <Button
                    key="back"
                    style={{
                      height: "100%",
                      padding: "16px",
                      float: "left",
                      pointerEvents: this.state.loadingRefundOrder
                        ? "none"
                        : "",
                      backgroundColor: this.state.loadingRefundOrder
                        ? "#52c41a"
                        : "#000",
                      borderColor: "#000",
                      color: "#fff",
                    }}
                    onClick={
                      this.state.loadingRefundOrder
                        ? () => {}
                        : () => this.completeSaleOrderReturn()
                    }
                  >
                    {this.state.loadingRefundOrder
                      ? "loading..."
                      : this.lang.BUTTON.DONE}
                  </Button>,
                  <Button
                    key="submit"
                    style={{
                      height: "100%",
                      padding: "16px",
                      backgroundColor: "#000",
                      borderColor: "#000",
                      color: "#fff",
                    }}
                    onClick={this.completeSaleOrderReturnCancel}
                  >
                    {this.lang.BUTTON.CANCEL}
                  </Button>,
                ]}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
              >
                <div>
                  <Row gutter={24}>
                    <Col span={3}></Col>
                    <Col span={6}>
                      <p>Name</p>
                    </Col>
                    <Col span={6}>
                      <p>Quantity</p>
                    </Col>
                    <Col span={6}>Split Quantity</Col>
                  </Row>
                  {this.refs.child.state.posProductsLists.map(
                    (item) =>
                      item.isAddProduct == false &&
                      item.isGroupItem == false &&
                      item.isComboChild == false &&
                      item.isCombo == false &&
                      item.status == "P" && (
                        <div>
                          <Row gutter={24}>
                            <Col span={3}>
                              <Checkbox
                                checked={
                                  this.state.injazSplitOrderLineRestModel
                                    .lines &&
                                  this.state.injazSplitOrderLineRestModel.lines
                                    .length > 0 &&
                                  this.state.injazSplitOrderLineRestModel.lines.filter(
                                    (i) => i.orderLineId == item.id,
                                  ).length > 0 &&
                                  true
                                }
                                onChange={(e) =>
                                  item.qty > 0
                                    ? this.orderLineSelect(e, item)
                                    : message.error(
                                        "Not Enough Quantity to split",
                                      )
                                }
                              ></Checkbox>
                            </Col>
                            <Col span={6}>
                              <p>
                                {this.refs.child.refPosSlip.state
                                  .productsListByClient.length > 0 &&
                                  this.refs.child.refPosSlip.state.productsListByClient.filter(
                                    (i) => {
                                      return i.id === item.product;
                                    },
                                  ).length > 0 &&
                                  this.refs.child.refPosSlip.state.productsListByClient.filter(
                                    (i) => {
                                      return i.id === item.product;
                                    },
                                  )[0].name}
                              </p>
                            </Col>
                            <Col span={3}>{item.qty}</Col>
                            <Col span={3}>
                              <div
                                style={{ height: "100%", background: "blue" }}
                                onClick={() => {
                                  this.state.injazSplitOrderLineRestModel
                                    .lines &&
                                    this.state.injazSplitOrderLineRestModel
                                      .lines.length > 0 &&
                                    this.state.injazSplitOrderLineRestModel.lines.filter(
                                      (i) => i.orderLineId == item.id,
                                    ).length > 0 &&
                                    this.changeSplitQty(
                                      Number(
                                        this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        )[0].splitQty,
                                      ) + 1,
                                      item,
                                    );
                                }}
                                className="inc_dec_btn"
                              >
                                +
                              </div>
                            </Col>
                            <Col span={6}>
                              <InputNumber
                                value={
                                  this.state.injazSplitOrderLineRestModel.lines
                                    ? this.state.injazSplitOrderLineRestModel
                                        .lines.length > 0
                                      ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        ).length > 0
                                        ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          )[0].splitQty
                                        : 0
                                      : 0
                                    : 0
                                }
                                onChange={(v) => this.changeSplitQty(v, item)}
                                disabled={
                                  this.state.injazSplitOrderLineRestModel.lines
                                    ? this.state.injazSplitOrderLineRestModel
                                        .lines.length > 0
                                      ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        ).length > 0
                                        ? false
                                        : true
                                      : true
                                    : true
                                }
                                max={item.qty}
                                min={1}
                                style={{ width: "100%" }}
                              />
                            </Col>
                            <Col span={3}>
                              <div
                                onClick={() => {
                                  this.state.injazSplitOrderLineRestModel
                                    .lines &&
                                    this.state.injazSplitOrderLineRestModel
                                      .lines.length > 0 &&
                                    this.state.injazSplitOrderLineRestModel.lines.filter(
                                      (i) => i.orderLineId == item.id,
                                    ).length > 0 &&
                                    this.changeSplitQty(
                                      Number(
                                        this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        )[0].splitQty,
                                      ) - 1,
                                      item,
                                    );
                                }}
                                className="inc_dec_btn"
                              >
                                -
                              </div>
                            </Col>
                          </Row>
                          {this.state.injazSplitOrderLineRestModel.lines &&
                            this.state.injazSplitOrderLineRestModel.lines
                              .length > 0 &&
                            this.state.injazSplitOrderLineRestModel.lines.filter(
                              (i) => i.orderLineId == item.id,
                            ).length > 0 &&
                            this.refs.child.state.posProductsLists.filter(
                              (i) => item.id == i.parentProduct,
                            ).length > 0 && (
                              <Col span={24}>
                                <p>Additional Products</p>
                              </Col>
                            )}
                          {this.state.injazSplitOrderLineRestModel.lines &&
                            this.state.injazSplitOrderLineRestModel.lines
                              .length > 0 &&
                            this.state.injazSplitOrderLineRestModel.lines.filter(
                              (i) => i.orderLineId == item.id,
                            ).length > 0 &&
                            this.refs.child.state.posProductsLists.map(
                              (itemchild) =>
                                (item.isAddProduct == true ||
                                  item.isGroupItem == false) &&
                                item.id == itemchild.parentProduct && (
                                  <Row gutter={24}>
                                    <Col span={3}>
                                      <Checkbox
                                        checked={
                                          this.state
                                            .injazSplitOrderLineRestModel
                                            .lines &&
                                          this.state
                                            .injazSplitOrderLineRestModel.lines
                                            .length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          ).length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          )[0].additionals.length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines
                                            .filter(
                                              (i) => i.orderLineId == item.id,
                                            )[0]
                                            .additionals.filter(
                                              (i) =>
                                                i.orderLineId == itemchild.id,
                                            ).length > 0 &&
                                          true
                                        }
                                        onChange={(e) =>
                                          itemchild.qty > 0
                                            ? this.orderLineSelect(e, itemchild)
                                            : message.error(
                                                "Not Enough Quantity to split",
                                              )
                                        }
                                      ></Checkbox>
                                    </Col>
                                    <Col span={6}>
                                      <p>
                                        {this.refs.child.refPosSlip.state
                                          .productsListByClient.length > 0 &&
                                          this.refs.child.refPosSlip.state.productsListByClient.filter(
                                            (i) => {
                                              return i.id === itemchild.product;
                                            },
                                          ).length > 0 &&
                                          this.refs.child.refPosSlip.state.productsListByClient.filter(
                                            (i) => {
                                              return i.id === itemchild.product;
                                            },
                                          )[0].name}
                                      </p>
                                    </Col>
                                    <Col span={3}>{itemchild.qty}</Col>
                                    <Col span={3}>
                                      <div
                                        onClick={() => {
                                          this.state
                                            .injazSplitOrderLineRestModel
                                            .lines &&
                                            this.state
                                              .injazSplitOrderLineRestModel
                                              .lines.length > 0 &&
                                            this.state.injazSplitOrderLineRestModel.lines.filter(
                                              (i) => i.orderLineId == item.id,
                                            ).length > 0 &&
                                            this.state.injazSplitOrderLineRestModel.lines.filter(
                                              (i) => i.orderLineId == item.id,
                                            )[0].additionals.length > 0 &&
                                            this.state.injazSplitOrderLineRestModel.lines
                                              .filter(
                                                (i) => i.orderLineId == item.id,
                                              )[0]
                                              .additionals.filter(
                                                (i) =>
                                                  i.orderLineId == itemchild.id,
                                              ).length > 0 &&
                                            this.changeSplitQty(
                                              Number(
                                                this.state.injazSplitOrderLineRestModel.lines
                                                  .filter(
                                                    (i) =>
                                                      i.orderLineId == item.id,
                                                  )[0]
                                                  .additionals.filter(
                                                    (i) =>
                                                      i.orderLineId ==
                                                      itemchild.id,
                                                  )[0].splitQty,
                                              ) + 1,
                                              itemchild,
                                            );
                                        }}
                                        className="inc_dec_btn"
                                      >
                                        +
                                      </div>
                                    </Col>
                                    <Col span={6}>
                                      <InputNumber
                                        value={
                                          this.state
                                            .injazSplitOrderLineRestModel.lines
                                            ? this.state
                                                .injazSplitOrderLineRestModel
                                                .lines.length > 0
                                              ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                  (i) =>
                                                    i.orderLineId == item.id,
                                                ).length > 0
                                                ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                    (i) =>
                                                      i.orderLineId == item.id,
                                                  ).length > 0
                                                  ? this.state.injazSplitOrderLineRestModel.lines
                                                      .filter(
                                                        (i) =>
                                                          i.orderLineId ==
                                                          item.id,
                                                      )[0]
                                                      .additionals.filter(
                                                        (i) =>
                                                          i.orderLineId ==
                                                          itemchild.id,
                                                      ).length > 0
                                                    ? this.state.injazSplitOrderLineRestModel.lines
                                                        .filter(
                                                          (i) =>
                                                            i.orderLineId ==
                                                            item.id,
                                                        )[0]
                                                        .additionals.filter(
                                                          (i) =>
                                                            i.orderLineId ==
                                                            itemchild.id,
                                                        )[0].splitQty
                                                    : 0
                                                  : 0
                                                : 0
                                              : 0
                                            : 0
                                        }
                                        onChange={(v) =>
                                          this.changeSplitQty(v, itemchild)
                                        }
                                        disabled={
                                          this.state
                                            .injazSplitOrderLineRestModel.lines
                                            ? this.state
                                                .injazSplitOrderLineRestModel
                                                .lines.length > 0
                                              ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                  (i) =>
                                                    i.orderLineId == item.id,
                                                ).length > 0
                                                ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                    (i) =>
                                                      i.orderLineId == item.id,
                                                  )[0].additionals.length > 0
                                                  ? this.state.injazSplitOrderLineRestModel.lines
                                                      .filter(
                                                        (i) =>
                                                          i.orderLineId ==
                                                          item.id,
                                                      )[0]
                                                      .additionals.filter(
                                                        (i) =>
                                                          i.orderLineId ==
                                                          itemchild.id,
                                                      ).length > 0
                                                    ? false
                                                    : true
                                                  : true
                                                : true
                                              : true
                                            : true
                                        }
                                        max={itemchild.qty}
                                        min={1}
                                        style={{ width: "100%" }}
                                      />
                                    </Col>
                                    <Col span={3}>
                                      <div
                                        onClick={() => {
                                          this.state
                                            .injazSplitOrderLineRestModel
                                            .lines &&
                                            this.state
                                              .injazSplitOrderLineRestModel
                                              .lines.length > 0 &&
                                            this.state.injazSplitOrderLineRestModel.lines.filter(
                                              (i) => i.orderLineId == item.id,
                                            ).length > 0 &&
                                            this.state.injazSplitOrderLineRestModel.lines.filter(
                                              (i) => i.orderLineId == item.id,
                                            )[0].additionals.length > 0 &&
                                            this.state.injazSplitOrderLineRestModel.lines
                                              .filter(
                                                (i) => i.orderLineId == item.id,
                                              )[0]
                                              .additionals.filter(
                                                (i) =>
                                                  i.orderLineId == itemchild.id,
                                              ).length > 0 &&
                                            this.changeSplitQty(
                                              Number(
                                                this.state.injazSplitOrderLineRestModel.lines
                                                  .filter(
                                                    (i) =>
                                                      i.orderLineId == item.id,
                                                  )[0]
                                                  .additionals.filter(
                                                    (i) =>
                                                      i.orderLineId ==
                                                      itemchild.id,
                                                  )[0].splitQty,
                                              ) - 1,
                                              itemchild,
                                            );
                                        }}
                                        className="inc_dec_btn"
                                      >
                                        -
                                      </div>
                                    </Col>
                                  </Row>
                                ),
                            )}
                          <div
                            style={{
                              width: "100%",
                              height: "2px",
                              backgroundColor: "gray",
                              borderColor: "gray",
                              color: "#fff",
                              marginTop: 10,
                              marginBottom: 10,
                            }}
                          ></div>
                        </div>
                      ),
                  )}
                </div>
              </Modal>
            )}
            {this.state.newOrderPopup && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <p className="title">{this.lang.BUTTON.S_ORDR_TYPE}</p>
                <div className="order_types_boxes">
                  {this.state.order_type.length > 0 &&
                    this.state.order_type.map((item) => (
                      <div
                        className="order_types_single_box"
                        onClick={() => {
                          this.createOrderonSelectOrderType(item.paramCode);
                        }}
                      >
                        <p className="order_types_label">{item.name}</p>
                      </div>
                    ))}
                </div>
                <div className="btns">
                  <Button
                    onClick={() =>
                      this.setState({
                        selectOrderTypeModal: false,
                        createSaleOrderInProgress: false,
                      })
                    }
                  >
                    {this.lang.BUTTON.CANCEL}
                  </Button>
                </div>
              </div>
            )}
            {this.state.splitOrderVisible && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <p className="title">
                  {this.lang.SPLIT_ORDER || "Split Order"}
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginBottom: "10px",
                    width: "100%",
                  }}
                >
                  <p style={{ fontWeight: "700", fontSize: "19px" }}>
                    {this.lang.NAME || "Name"}
                  </p>
                  <p style={{ fontWeight: "700", fontSize: "19px" }}>
                    {this.lang.QUANTITY || "Quantity"}
                  </p>
                  <p style={{ fontWeight: "700", fontSize: "19px" }}>
                    {this.lang.SPLIT_QUANTITY || "Split Quantity"}
                  </p>
                </div>
                {this.refs.child.state.posProductsLists.map(
                  (item) =>
                    item.isAddProduct == false &&
                    item.isGroupItem == false &&
                    item.isComboChild == false &&
                    item.isCombo == false &&
                    (item.status == "DR" || item.status == "K") && (
                      <div key={item.id}>
                        <Row gutter={24}>
                          <Col span={3}>
                            <Checkbox
                              checked={
                                this.state.injazSplitOrderLineRestModel.lines &&
                                this.state.injazSplitOrderLineRestModel.lines
                                  .length > 0 &&
                                this.state.injazSplitOrderLineRestModel.lines.filter(
                                  (i) => i.orderLineId == item.id,
                                ).length > 0 &&
                                true
                              }
                              onChange={(e) =>
                                item.qty > 0
                                  ? this.orderLineSelect(e, item)
                                  : message.error(
                                      this.lang.NOT_ENOUGH_QUANTITY_TO_SPLIT ||
                                        "Not Enough Quantity to split",
                                    )
                              }
                            ></Checkbox>
                          </Col>
                          <Col span={6}>
                            <p>
                              {this.refs.child.refPosSlip.state
                                .productsListByClient.length > 0 &&
                                this.refs.child.refPosSlip.state.productsListByClient.filter(
                                  (i) => {
                                    return i.id === item.product;
                                  },
                                ).length > 0 &&
                                this.refs.child.refPosSlip.state.productsListByClient.filter(
                                  (i) => {
                                    return i.id === item.product;
                                  },
                                )[0].name}
                            </p>
                          </Col>
                          <Col span={3}>
                            <span style={{ color: "var(--cr-txt-dark)" }}>
                              {item.qty}
                            </span>
                          </Col>
                          <Col span={3}>
                            <div
                              onClick={() => {
                                this.state.injazSplitOrderLineRestModel.lines &&
                                  this.state.injazSplitOrderLineRestModel.lines
                                    .length > 0 &&
                                  this.state.injazSplitOrderLineRestModel.lines.filter(
                                    (i) => i.orderLineId == item.id,
                                  ).length > 0 &&
                                  this.changeSplitQty(
                                    Number(
                                      this.state.injazSplitOrderLineRestModel.lines.filter(
                                        (i) => i.orderLineId == item.id,
                                      )[0].splitQty,
                                    ) + 1,
                                    item,
                                  );
                              }}
                              className="inc_dec_btn"
                            >
                              +
                            </div>
                          </Col>
                          <Col span={6}>
                            <InputNumber
                              value={
                                this.state.injazSplitOrderLineRestModel.lines
                                  ? this.state.injazSplitOrderLineRestModel
                                      .lines.length > 0
                                    ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                        (i) => i.orderLineId == item.id,
                                      ).length > 0
                                      ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        )[0].splitQty
                                      : 0
                                    : 0
                                  : 0
                              }
                              onChange={(v) => this.changeSplitQty(v, item)}
                              disabled={
                                this.state.injazSplitOrderLineRestModel.lines
                                  ? this.state.injazSplitOrderLineRestModel
                                      .lines.length > 0
                                    ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                        (i) => i.orderLineId == item.id,
                                      ).length > 0
                                      ? false
                                      : true
                                    : true
                                  : true
                              }
                              max={item.qty}
                              min={1}
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col span={3}>
                            <div
                              onClick={() => {
                                this.state.injazSplitOrderLineRestModel.lines &&
                                  this.state.injazSplitOrderLineRestModel.lines
                                    .length > 0 &&
                                  this.state.injazSplitOrderLineRestModel.lines.filter(
                                    (i) => i.orderLineId == item.id,
                                  ).length > 0 &&
                                  this.changeSplitQty(
                                    Number(
                                      this.state.injazSplitOrderLineRestModel.lines.filter(
                                        (i) => i.orderLineId == item.id,
                                      )[0].splitQty,
                                    ) - 1,
                                    item,
                                  );
                              }}
                              className="inc_dec_btn"
                            >
                              -
                            </div>
                          </Col>
                        </Row>
                        {this.state.injazSplitOrderLineRestModel.lines &&
                          this.state.injazSplitOrderLineRestModel.lines.length >
                            0 &&
                          this.state.injazSplitOrderLineRestModel.lines.filter(
                            (i) => i.orderLineId == item.id,
                          ).length > 0 &&
                          this.refs.child.state.posProductsLists.filter(
                            (i) => item.id == i.parentProduct,
                          ).length > 0 && (
                            <Col span={24}>
                              <p>
                                {this.lang.ADDITIONAL_PRODUCTS ||
                                  "Additional Products"}
                              </p>
                            </Col>
                          )}
                        {this.state.injazSplitOrderLineRestModel.lines &&
                          this.state.injazSplitOrderLineRestModel.lines.length >
                            0 &&
                          this.state.injazSplitOrderLineRestModel.lines.filter(
                            (i) => i.orderLineId == item.id,
                          ).length > 0 &&
                          this.refs.child.state.posProductsLists.map(
                            (itemchild) =>
                              (item.isAddProduct == true ||
                                item.isGroupItem == false) &&
                              item.id == itemchild.parentProduct && (
                                <Row key={itemchild.id} gutter={24}>
                                  <Col span={3}>
                                    <Checkbox
                                      checked={
                                        this.state.injazSplitOrderLineRestModel
                                          .lines &&
                                        this.state.injazSplitOrderLineRestModel
                                          .lines.length > 0 &&
                                        this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        ).length > 0 &&
                                        this.state.injazSplitOrderLineRestModel.lines.filter(
                                          (i) => i.orderLineId == item.id,
                                        )[0].additionals.length > 0 &&
                                        this.state.injazSplitOrderLineRestModel.lines
                                          .filter(
                                            (i) => i.orderLineId == item.id,
                                          )[0]
                                          .additionals.filter(
                                            (i) =>
                                              i.orderLineId == itemchild.id,
                                          ).length > 0 &&
                                        true
                                      }
                                      onChange={(e) =>
                                        itemchild.qty > 0
                                          ? this.orderLineSelect(e, itemchild)
                                          : message.error(
                                              this.lang
                                                .NOT_ENOUGH_QUANTITY_TO_SPLIT ||
                                                "Not Enough Quantity to split",
                                            )
                                      }
                                    ></Checkbox>
                                  </Col>
                                  <Col span={6}>
                                    <p>
                                      {this.refs.child.refPosSlip.state
                                        .productsListByClient.length > 0 &&
                                        this.refs.child.refPosSlip.state.productsListByClient.filter(
                                          (i) => {
                                            return i.id === itemchild.product;
                                          },
                                        ).length > 0 &&
                                        this.refs.child.refPosSlip.state.productsListByClient.filter(
                                          (i) => {
                                            return i.id === itemchild.product;
                                          },
                                        )[0].name}
                                    </p>
                                  </Col>
                                  <Col span={3}>{itemchild.qty}</Col>
                                  <Col span={3}>
                                    <div
                                      onClick={() => {
                                        this.state.injazSplitOrderLineRestModel
                                          .lines &&
                                          this.state
                                            .injazSplitOrderLineRestModel.lines
                                            .length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          ).length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          )[0].additionals.length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines
                                            .filter(
                                              (i) => i.orderLineId == item.id,
                                            )[0]
                                            .additionals.filter(
                                              (i) =>
                                                i.orderLineId == itemchild.id,
                                            ).length > 0 &&
                                          this.changeSplitQty(
                                            Number(
                                              this.state.injazSplitOrderLineRestModel.lines
                                                .filter(
                                                  (i) =>
                                                    i.orderLineId == item.id,
                                                )[0]
                                                .additionals.filter(
                                                  (i) =>
                                                    i.orderLineId ==
                                                    itemchild.id,
                                                )[0].splitQty,
                                            ) + 1,
                                            itemchild,
                                          );
                                      }}
                                      className="inc_dec_btn"
                                    >
                                      +
                                    </div>
                                  </Col>
                                  <Col span={6}>
                                    <InputNumber
                                      value={
                                        this.state.injazSplitOrderLineRestModel
                                          .lines
                                          ? this.state
                                              .injazSplitOrderLineRestModel
                                              .lines.length > 0
                                            ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                (i) => i.orderLineId == item.id,
                                              ).length > 0
                                              ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                  (i) =>
                                                    i.orderLineId == item.id,
                                                ).length > 0
                                                ? this.state.injazSplitOrderLineRestModel.lines
                                                    .filter(
                                                      (i) =>
                                                        i.orderLineId ==
                                                        item.id,
                                                    )[0]
                                                    .additionals.filter(
                                                      (i) =>
                                                        i.orderLineId ==
                                                        itemchild.id,
                                                    ).length > 0
                                                  ? this.state.injazSplitOrderLineRestModel.lines
                                                      .filter(
                                                        (i) =>
                                                          i.orderLineId ==
                                                          item.id,
                                                      )[0]
                                                      .additionals.filter(
                                                        (i) =>
                                                          i.orderLineId ==
                                                          itemchild.id,
                                                      )[0].splitQty
                                                  : 0
                                                : 0
                                              : 0
                                            : 0
                                          : 0
                                      }
                                      onChange={(v) =>
                                        this.changeSplitQty(v, itemchild)
                                      }
                                      disabled={
                                        this.state.injazSplitOrderLineRestModel
                                          .lines
                                          ? this.state
                                              .injazSplitOrderLineRestModel
                                              .lines.length > 0
                                            ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                (i) => i.orderLineId == item.id,
                                              ).length > 0
                                              ? this.state.injazSplitOrderLineRestModel.lines.filter(
                                                  (i) =>
                                                    i.orderLineId == item.id,
                                                )[0].additionals.length > 0
                                                ? this.state.injazSplitOrderLineRestModel.lines
                                                    .filter(
                                                      (i) =>
                                                        i.orderLineId ==
                                                        item.id,
                                                    )[0]
                                                    .additionals.filter(
                                                      (i) =>
                                                        i.orderLineId ==
                                                        itemchild.id,
                                                    ).length > 0
                                                  ? false
                                                  : true
                                                : true
                                              : true
                                            : true
                                          : true
                                      }
                                      max={itemchild.qty}
                                      min={1}
                                      style={{ width: "100%" }}
                                    />
                                  </Col>
                                  <Col span={3}>
                                    <div
                                      onClick={() => {
                                        this.state.injazSplitOrderLineRestModel
                                          .lines &&
                                          this.state
                                            .injazSplitOrderLineRestModel.lines
                                            .length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          ).length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines.filter(
                                            (i) => i.orderLineId == item.id,
                                          )[0].additionals.length > 0 &&
                                          this.state.injazSplitOrderLineRestModel.lines
                                            .filter(
                                              (i) => i.orderLineId == item.id,
                                            )[0]
                                            .additionals.filter(
                                              (i) =>
                                                i.orderLineId == itemchild.id,
                                            ).length > 0 &&
                                          this.changeSplitQty(
                                            Number(
                                              this.state.injazSplitOrderLineRestModel.lines
                                                .filter(
                                                  (i) =>
                                                    i.orderLineId == item.id,
                                                )[0]
                                                .additionals.filter(
                                                  (i) =>
                                                    i.orderLineId ==
                                                    itemchild.id,
                                                )[0].splitQty,
                                            ) - 1,
                                            itemchild,
                                          );
                                      }}
                                      className="inc_dec_btn"
                                    >
                                      -
                                    </div>
                                  </Col>
                                </Row>
                              ),
                          )}
                      </div>
                    ),
                )}
                <div className="btns">
                  <Button key="back" onClick={this.splitOrderHandleOk}>
                    {this.lang.BUTTON.DONE}
                  </Button>
                  <Button key="submit" onClick={this.splitOrderCancel}>
                    {this.lang.BUTTON.CANCEL}
                  </Button>
                </div>
              </div>
            )}
            {this.state.visible && (
              <Modal
                visible={this.state.visible}
                title={this.lang.BUTTON.OPTIONS}
                okText={this.props.lang.OK}
                cancelText={this.props.lang.CANCEL}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
              >
                <Row gutter={12} className="optionButton">
                  <Col span={8}>
                    <Button
                      onClick={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "guests",
                          modaltitle: this.lang.BUTTON.GUEST,
                        })
                      }
                    >
                      {this.lang.BUTTON.GUEST}{" "}
                    </Button>
                  </Col>
                  <Col span={8}>
                    <Button
                      onClick={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "chtable",
                          modaltitle: this.lang.BUTTON.CHANGETABLE,
                        })
                      }
                    >
                      {this.lang.BUTTON.CHANGETABLE}{" "}
                    </Button>
                  </Col>
                  <Col span={8}>
                    <Button
                      onClick={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "enotes",
                          modaltitle: this.lang.BUTTON.EXTRANOTES,
                        })
                      }
                    >
                      {this.lang.BUTTON.EXTRANOTES}{" "}
                    </Button>
                  </Col>
                </Row>
                <Row gutter={12} className="optionButton">
                  <Col span={8}>
                    <Button
                      onClick={() =>
                        this.setState({
                          visible2: true,
                          modaltype: "orderType",
                          modaltitle: this.lang.BUTTON.ORDERTYPE,
                        })
                      }
                    >
                      {this.lang.BUTTON.ORDERTYPE}{" "}
                    </Button>
                  </Col>
                  <Col span={8}>
                    <Button
                      className="optionButton"
                      disabled={
                        this.state.saleOrderData.orderType == "OL"
                          ? false
                          : true
                      }
                      onClick={() => this.setState({ changeToDineIN: true })}
                    >
                      {this.lang.BUTTON.ASSIGNTABLE}
                    </Button>
                  </Col>
                  {/* <Col span={8}>
                    <Button
                      disabled={
                        !(
                          JSON.parse(
                            localStorage.getItem("userData")
                          ).roles.split(",").length > 0 &&
                          JSON.parse(localStorage.getItem("userData"))
                            .roles.split(",")
                            .filter((a) => a === "PRINT_CHECK").length > 0
                        )
                      }
                      onClick={() => {
                        this.buildMessage1("rPrint");
                      }}
                    >
                      {this.lang.BUTTON.PRINTCHECK}{" "}
                    </Button>
                  </Col>
                 */}
                </Row>
                <Row gutter={12} className="optionButton">
                  <Col span={8}>
                    {this.state.showButton && (
                      <Button onClick={() => this.modalOpen("priority")}>
                        {this.lang.BUTTON.PRIORITY}
                      </Button>
                    )}
                  </Col>
                  <Col span={8}>
                    {(this.state.showButton &&
                      this.state.saleOrderData.status == "K") ||
                    this.state.saleOrderData.status == "DR" ? (
                      <Button onClick={() => this.modalOpen("selectPayment")}>
                        {this.lang.BUTTON.PAYMENTMETHOD}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          this.buildMessage1("cPrint");
                        }}
                      >
                        {this.lang.BUTTON.PRINTCOPY}{" "}
                      </Button>
                    )}
                  </Col>
                  <Col span={8}>
                    {this.state.showButton && (
                      <Button onClick={() => this.modalOpen("notes")}>
                        {this.lang.BUTTON.NOTES}
                      </Button>
                    )}
                  </Col>
                </Row>
              </Modal>
            )}
            {this.state.visible2 && (
              <Modal
                visible={this.state.visible2}
                title={this.state.modaltitle}
                footer={false}
                onOk={this.handleOk2}
                onCancel={this.handleCancel2}
              >
                {this.state.modaltype == "orderType" ? (
                  <div>
                    <Row>
                      <Col col={20}>
                        <Select
                          placeholder={this.lang.BUTTON.S_ORDR_TYPE}
                          onChange={this.updateOrder}
                          style={{ width: "100%" }}
                        >
                          {this.state.order_type.map((item) => {
                            return (
                              <Select.Option
                                key={item.paramCode}
                                value={item.paramCode}
                              >
                                {item.name}{" "}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Col>
                    </Row>
                  </div>
                ) : this.state.modaltype == "guests" ? (
                  <div>
                    <Row gutter={12} className="optionButton">
                      <Col span={24}>
                        <InputNumber
                          value={this.state.nofGuests}
                          min={0}
                          style={{ width: "100%", textAlign: "center" }}
                          onChange={(e) => {
                            this.setState({ nofGuests: e });
                          }}
                          placeholder={
                            this.lang.ENTER_NO_OF_GUESTS ||
                            "Enter No. of guests"
                          }
                        />
                        <Card>
                          <div
                            style={{
                              width: "100%",
                              height: "70%",
                              margin: "0 auto",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "54px",
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                className="posButton  calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  width: "100%",
                                  height: "100%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(1)
                                }
                              >
                                1
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  width: "100%",
                                  height: "100%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(2)
                                }
                              >
                                2
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  width: "100%",
                                  height: "100%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(3)
                                }
                              >
                                3
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                height: "54px",
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                  borderTop: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(4)
                                }
                              >
                                4
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  borderTop: "none",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(5)
                                }
                              >
                                5
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  borderTop: "none",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(6)
                                }
                              >
                                6
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                height: "54px",
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                  borderTop: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(7)
                                }
                              >
                                7
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  borderTop: "none",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(8)
                                }
                              >
                                8
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  borderTop: "none",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(9)
                                }
                              >
                                9
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                height: "54px",
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                  borderTop: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests("c")
                                }
                              >
                                {this.lang.CLEAR || "C"}
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  borderTop: "none",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "none",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests(0)
                                }
                              >
                                0
                              </div>
                              <div
                                className="posButton calculatorPayButton"
                                style={{
                                  border: "1px solid #000",
                                  borderTop: "none",
                                  width: "100%",
                                  height: "54px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                onClick={() =>
                                  this.calculatorFunctionnoOfGuests("b")
                                }
                              >
                                <Icon type="close" />
                              </div>
                            </div>
                          </div>
                        </Card>
                      </Col>
                    </Row>

                    <Button
                      style={{
                        width: 100,
                        margin: "20px auto 0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={this.updateOrder}
                    >
                      {this.lang.BUTTON.SAVE}
                    </Button>
                  </div>
                ) : this.state.modaltype == "chtable" ? (
                  <div>
                    <Row gutter={24} style={{ marginTop: 20 }}>
                      <Col span={24}>
                        {this.state.avaiableTables.length > 0 ? (
                          <Select
                            placeholder={this.lang.BUTTON.CHANGETABLE}
                            onChange={this.updateOrder}
                            style={{ width: "100%" }}
                            defaultValue={this.props.posStorage.floorId}
                          >
                            {this.state.avaiableTables.length > 0 &&
                              this.state.avaiableTables.map((item) => (
                                <Select.Option
                                  style={{ width: "100%" }}
                                  value={item.id}
                                  key={item.id}
                                >
                                  {item.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select
                            placeholder={this.lang.BUTTON.CHANGETABLE}
                            onChange={this.updateOrder}
                            style={{ width: "100%" }}
                            defaultValue={this.props.posStorage.floorId}
                          >
                            {this.state.tables.length > 0 &&
                              this.state.tables
                                .filter(
                                  (ii) =>
                                    ii.id === this.props.posStorage.floorId,
                                )
                                .map((item) => (
                                  <Select.Option value={item.id} key={item.id}>
                                    {item.name}
                                  </Select.Option>
                                ))}
                          </Select>
                        )}
                      </Col>
                    </Row>
                  </div>
                ) : this.state.modaltype == "enotes" ? (
                  <div>
                    <Row gutter={24}>
                      <Col span={24}>
                        <Input.TextArea
                          onChange={(e) => {
                            this.setState({ extraNotesInput: e.target.value });
                          }}
                          placeholder={this.lang.BUTTON.WRITE_EXTRA_NOTES}
                        />
                      </Col>
                    </Row>
                    <Button
                      style={{
                        width: 100,
                        margin: "20px auto 0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={this.updateOrder}
                    >
                      {this.lang.BUTTON.SAVE}
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </Modal>
            )}
            {this.state.changeToDineIN && (
              <Modal
                className="changeOrderTypeOnlineOrder"
                visible={this.state.changeToDineIN}
                title={this.lang.BUTTON.CHANG_ONLINE_DINEIN}
                footer={false}
                onOk={this.changeToDineINOk}
                onCancel={this.changeToDineINCancel}
              >
                <Select
                  onChange={(v) => this.floorSelectedForchangeToDineIN(v)}
                  style={{ width: "100%" }}
                  placeholder={this.lang.BUTTON.S_TBLE}
                >
                  {this.state.floors.length > 0 &&
                    this.state.floors.map((floor) => (
                      <Select.Option id={floor.id} key={floor.id}>
                        {" "}
                        {localStorage.getItem("lang") == "EN"
                          ? floor.name
                          : floor.nameAr}{" "}
                      </Select.Option>
                    ))}
                </Select>
                <Select
                  disabled={
                    this.state.tableschangeToDineIN.length > 0 ? false : true
                  }
                  onChange={(v) => this.tablesSelectedForchangeToDineIN(v)}
                  style={{ width: "100%" }}
                  placeholder={this.lang.BUTTON.S_TBLE}
                >
                  {this.state.tableschangeToDineIN.length > 0 &&
                    this.state.tableschangeToDineIN.map((table) => (
                      <Select.Option id={table.id} key={table.id}>
                        {" "}
                        {localStorage.getItem("lang") == "EN"
                          ? table.name
                          : table.nameAr}{" "}
                      </Select.Option>
                    ))}
                </Select>

                <InputNumber
                  style={{ width: "100%" }}
                  onChange={(v) =>
                    this.setState({ noOfGuestchangeToDineIN: v })
                  }
                  placeholder={this.lang.BUTTON.GUEST}
                />
                <Button onClick={this.changeToDineINCancel}>
                  {this.lang.BUTTON.CANCEL}
                </Button>
                <Button
                  disabled={
                    this.state.tableIdchangeToDineIN &&
                    this.state.noOfGuestchangeToDineIN
                      ? false
                      : true
                  }
                  onClick={this.changeToDineINOk}
                >
                  {this.lang.BUTTON.CHANGE}
                </Button>
              </Modal>
            )}
            {this.state.orderSearchVisible && (
              <Modal
                visible={this.state.orderSearchVisible}
                title={this.lang.BUTTON.SEARCH_ORDER}
                className="onlineOrderModal-2"
                onCancel={this.orderSearchVisibleCancel}
                footer={[
                  <Button
                    onClick={() => this.openOrderHandler()}
                    style={{
                      float: "left",
                      display:
                        this.state.searchOrderList.length > 0
                          ? "inline"
                          : "none",
                      background: "#CC0000",
                      border: "#CC0000",
                      color: "#fff",
                    }}
                  >
                    {this.lang.BUTTON.OPEN}
                  </Button>,
                  <Button onClick={this.orderSearchVisibleCancel}>
                    {this.lang.BUTTON.CANCEL}
                  </Button>,
                ]}
              >
                <Row gutter={24}>
                  <Col span={8}>
                    <Input
                      ref="tokenNo"
                      placeholder={this.lang.TOKEN_NO}
                      onKeyUp={(e) =>
                        e.keyCode === 13 &&
                        this.getSearchOrders(this.refs.orderno.state.value)
                      }
                    />
                  </Col>
                  <Col span={8}>
                    <Input
                      ref="orderno"
                      placeholder={this.lang.BUTTON.ORDR_NO}
                      onKeyUp={(e) =>
                        e.keyCode === 13 &&
                        this.getSearchOrders(this.refs.orderno.state.value)
                      }
                    />
                  </Col>

                  <Col span={8} style={{ display: "none" }}>
                    <DatePicker
                      id="fromDate"
                      placeholder={this.lang.BUTTON.FROM_DATE}
                    />
                  </Col>
                  <Col span={8} style={{ display: "none" }}>
                    <DatePicker
                      id="toDate"
                      placeholder={this.lang.BUTTON.To_DATE}
                    />
                  </Col>
                  <Col span={8}>
                    <Button
                      id="orderSearchBTN"
                      style={{ width: "100%", color: "#fff" }}
                      onClick={(a) =>
                        this.getSearchOrders(
                          this.refs.orderno.state.value,
                          this.refs.tokenNo.state.value,
                        )
                      }
                    >
                      {this.lang.BUTTON.SEARCH}
                    </Button>
                  </Col>
                </Row>
                {this.state.searchOrderList.length > 0 ? (
                  <React.Fragment>
                    <Row>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.ORDR_NO}>
                          {this.state.searchOrderList[0].documentNo}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.NOTES_LABEL}>
                          {this.state.order_status.length > 0 &&
                            this.state.order_status.filter(
                              (item) =>
                                item.paramCode ==
                                this.state.searchOrderList[0].status,
                            ).length > 0 &&
                            this.state.order_status.filter(
                              (item) =>
                                item.paramCode ==
                                this.state.searchOrderList[0].status,
                            )[0].name}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.DATE}>
                          {this.state.searchOrderList[0].orderDate}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.BRANCH}>
                          {this.state.branchsList.length > 0 &&
                            this.state.branchsList.filter(
                              (item) =>
                                item.id == this.state.searchOrderList[0].branch,
                            ).length > 0 &&
                            this.state.branchsList.filter(
                              (item) =>
                                item.id == this.state.searchOrderList[0].branch,
                            )[0].name}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.SELECTCUSTOMER}>
                          {this.state.customerList.length > 0 &&
                            this.state.customerList.filter(
                              (item) =>
                                item.id ==
                                this.state.searchOrderList[0].customer,
                            ).length > 0 &&
                            this.state.customerList.filter(
                              (item) =>
                                item.id ==
                                this.state.searchOrderList[0].customer,
                            )[0].name}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.WAREHOUSE}>
                          {this.state.warehousesList.length > 0 &&
                            this.state.warehousesList.filter(
                              (item) =>
                                item.id ==
                                this.state.searchOrderList[0].warehouse,
                            ).length > 0 &&
                            this.state.warehousesList.filter(
                              (item) =>
                                item.id ==
                                this.state.searchOrderList[0].warehouse,
                            )[0].name}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.NOTES_LABEL}>
                          {this.state.searchOrderList[0].notes}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.EXTRA_NOTES}>
                          {this.state.searchOrderList[0].extraNotes}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.PAYMETHOD}>
                          {this.state.paymentMethodsList.length > 0 &&
                            this.state.paymentMethodsList.filter(
                              (item) =>
                                item.id ==
                                this.state.searchOrderList[0].payMethod,
                            ).length > 0 &&
                            this.state.paymentMethodsList.filter(
                              (item) =>
                                item.id ==
                                this.state.searchOrderList[0].payMethod,
                            )[0].name}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.PRIORITY}>
                          {this.state.searchOrderList[0].priority}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.TOTAL_AMNT}>
                          {this.state.searchOrderList[0].totalNet}
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label={this.lang.BUTTON.REFUND}>
                          {this.state.searchOrderList[0].refundAmt}
                        </Form.Item>
                      </Col>
                    </Row>
                  </React.Fragment>
                ) : (
                  <Table
                    dataSource={this.state.draftSaleOrderList}
                    columns={this.draftSaleOrderListColumns}
                    rowKey="id"
                  />
                )}
              </Modal>
            )}
            {this.state.discountPopUp && (
              // <Modal
              //   visible={this.state.discountPopUp}
              //   className="Payment"
              //   title={"Discount"}
              //   onCancel={() =>
              //     this.setState({ discountPopUp: false, isDiscount: false })
              //   }
              //   footer={false}
              // >
              //   {/* <Row>
              //     <Col span={24}>
              //       {" is Discount ?? "}
              //       <Switch
              //         checked={this.state.isDiscount}
              //         onChange={(v) => this.setState({ isDiscount: v })} />
              //     </Col>
              //   </Row> */}
              // </Modal>

              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <p className="title">{this.lang.DISCOUNT || "Discount"}</p>
                <Row gutter={24}>
                  <Col span={24}>
                    <Checkbox
                      size="small"
                      checked={this.state.isDiscountP}
                      onChange={(v) =>
                        this.setState({ isDiscountP: v.target.checked })
                      }
                    >
                      {this.lang.PERCENTAGE || "Percentage"}
                    </Checkbox>
                    <Checkbox
                      size="small"
                      checked={!this.state.isDiscountP}
                      onChange={(v) =>
                        this.setState({ isDiscountP: !v.target.checked })
                      }
                    >
                      {this.lang.AMOUNT || "Amount"}
                    </Checkbox>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={24}>
                    {!this.state.isDiscountP ? (
                      <InputNumber
                        onChange={(v) => {
                          this.setState({
                            disAmt: v,
                          });
                        }}
                        placeholder={
                          this.lang.DISCOUNT_AMOUNT || "Discount Amount"
                        }
                        style={{ width: "100%" }}
                      />
                    ) : (
                      <InputNumber
                        onChange={(v) => {
                          this.setState({
                            disPrctg: v,
                          });
                        }}
                        min={0}
                        max={100}
                        placeholder={
                          this.lang.DISCOUNT_PERCENTAGE || "Discount Percentage"
                        }
                        style={{ width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={24}>
                    <br />
                    <Button
                      disabled={
                        this.state.isDiscountP
                          ? this.state.disAmt
                            ? false
                            : this.state.disPrctg
                            ? false
                            : true
                          : true
                      }
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={() => {
                        this.setState({
                          discountPopUp: false,
                          isDiscount: true,
                        });
                      }}
                    >
                      {this.lang.BUTTON.SAVE || "Save"}
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {this.state.payment && (
              <Modal
                visible={this.state.payment}
                className="Payment"
                title={this.lang.PAYMENT}
                onCancel={() => this.setState({ payment: false })}
                footer={false}
                bodyStyle={{ maxHeight: "80vh", height: "80vh" }}
              >
                <PaymentPopUp
                  deletuser={this.deletuser}
                  tablename={this.state.userdataobj}
                  deliveryPerson={this.state.saleOrderData.deliveryPerson}
                  isDiscount={this.state.isDiscount}
                  isDiscountP={this.state.isDiscountP}
                  disAmt={this.state.disAmt}
                  disPrctg={this.state.disPrctg}
                  ref={this.myRef}
                  {...this.props}
                  saleOrderByIDFunction={(a) => {
                    this.saleOrderByID(null, a);
                  }}
                  cancelPopUp={() => this.setState({ payment: false })}
                  paymentok={(v, cashPaidAmount) => {
                    this.buildMessage1("payment", v, cashPaidAmount);
                    this.setState({ payment: false });
                    this.getBranchbyIdData(
                      JSON.parse(localStorage.getItem("userData")).branchId,
                    ).then((res) => {
                      if (res.isPrntKitPayComp) {
                        // this.setState({
                        //   userdataobj:{}
                        // });
                        // let thatt =  this;

                        this.buildMessage1(
                          "kitchen",
                          null,
                          null,
                          null,
                          true,
                          this.state.tables,
                          this.state.floors,
                        );
                      }
                    });
                  }}
                />
              </Modal>
            )}
            {this.state.onlineOrderShow && (
              <Modal
                visible={this.state.onlineOrderShow}
                title={this.lang.BUTTON.ONLINE_ORDERS_MODAL}
                onCancel={() => {
                  this.setState({
                    onlineOrderShow: false,
                    onlineOrderData: {},
                  });
                }}
                footer={[
                  <Button
                    key="back"
                    style={{ background: "green !important" }}
                    onClick={() => {
                      axios({
                        url: API_URL + "acceptOnlineOrder",
                        method: "POST",
                        headers: {
                          Authorization:
                            localStorage.getItem("tokenType") +
                            " " +
                            localStorage.getItem("accessToken"),
                          "Content-Type": "application/json",
                        },
                        data: {
                          id: this.state.onlineOrderData.id,
                          lang: localStorage.getItem("lang"),
                        },
                      }).then((res) => {
                        if (res.data.success) {
                          this.onComponentDidMountRender();
                          let name;

                          name =
                            this.state.customerList.length > 0 &&
                            this.state.customerList.filter(
                              (item) =>
                                item.id == this.state.onlineOrderData.name,
                            ).length > 0 &&
                            this.state.customerList.filter(
                              (item) =>
                                item.id == this.state.onlineOrderData.name,
                            )[0].name;
                          let posStorage = {
                            customer: this.state.onlineOrderData.name,
                            customerName: this.state.onlineOrderData.name,
                            orderId: res.data.object,
                            floorId: this.state.onlineOrderData.flrTable,
                            pos: true,
                          };

                          this.props.posStorageAction(posStorage);
                          this.props.history.push("pos");
                          this.setState({
                            onlineOrderShow: false,
                            onlineOrderData: {},
                          });
                          window.location.reload();
                        } else {
                          message.error(res.data.message);
                        }
                      });
                    }}
                  >
                    {this.lang.BUTTON.ACCEPT}
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    style={{ background: "red !important" }}
                    onClick={() => {
                      axios({
                        url: API_URL + "rejectOnlineOrder",
                        method: "POST",
                        headers: {
                          Authorization:
                            localStorage.getItem("tokenType") +
                            " " +
                            localStorage.getItem("accessToken"),
                          "Content-Type": "application/json",
                        },
                        data: {
                          id: this.state.onlineOrderData.id,
                          lang: localStorage.getItem("lang"),
                        },
                      }).then((res) => {
                        this.setState({
                          onlineOrderShow: false,
                          onlineOrderData: {},
                        });
                      });
                    }}
                  >
                    {this.lang.BUTTON.REJECT}
                  </Button>,
                ]}
              >
                <Row gutter={24}>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.CUST_NAME}>
                      {this.state.onlineOrderData.name}
                    </FormItem>
                  </Col>

                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.ORDR_NO}>
                      {this.state.onlineOrderData.documentNo}
                    </FormItem>
                  </Col>

                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.PAYMETHOD}>
                      {this.state.paymentMethodsList.length > 0 &&
                        this.state.paymentMethodsList.filter(
                          (item) =>
                            item.id == this.state.onlineOrderData.payMethod,
                        ).length > 0 &&
                        this.state.paymentMethodsList.filter(
                          (item) =>
                            item.id == this.state.onlineOrderData.payMethod,
                        )[0].name}
                    </FormItem>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.PH_NO}>
                      {this.state.onlineOrderData.phoneNo}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.ADDRESS}>
                      {this.state.onlineOrderData.address}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={this.lang.BUTTON.TOTAL}>
                      {this.state.onlineOrderData.totalNet}
                    </FormItem>
                  </Col>
                </Row>
                {this.state.onlineOrderData.flrTable && (
                  <Row>
                    <Col span={8}>
                      <FormItem label={"Table"}>
                        {this.state.flrTablesListByClient.length > 0 &&
                          this.state.flrTablesListByClient.filter(
                            (i) => i.id == this.state.onlineOrderData.flrTable,
                          ).length > 0 &&
                          this.state.flrTablesListByClient.filter(
                            (i) => i.id == this.state.onlineOrderData.flrTable,
                          )[0].name}
                      </FormItem>
                    </Col>
                  </Row>
                )}
                <Row gutter={24}>
                  <Col span={8}>{this.lang.BUTTON.QTY}</Col>
                  <Col span={8}>{this.lang.BUTTON.ITEM_NAME}</Col>
                  <Col span={8}>{this.lang.BUTTON.TOTAL}</Col>
                </Row>
                {this.state.onlineOrderData.lines &&
                  this.state.onlineOrderData.lines.length > 0 &&
                  this.state.onlineOrderData.lines.map((item, index) => (
                    <React.Fragment>
                      <Row
                        key={index}
                        gutter={24}
                        style={{
                          border: "1px solid #F2F3F4",
                          background: "#F2F3F4",
                          marginBottom: "3px",
                        }}
                      >
                        <Col span={8}>{item.qty}</Col>
                        <Col span={8}>
                          {this.state.posProductsList &&
                            this.state.posProductsList.length > 0 &&
                            this.state.posProductsList.filter(
                              (ii) => ii.id === item.product,
                            ).length > 0 &&
                            this.state.posProductsList.filter(
                              (ii) => ii.id === item.product,
                            )[0].name}
                        </Col>
                        <Col span={8}>{item.totalNetLine}</Col>
                      </Row>
                      {item.additionals.length > 0 &&
                        item.additionals.map((add, i) => (
                          <Row
                            key={index}
                            gutter={24}
                            style={{
                              border: "1px solid #F2F3F4",
                              background: "#F2F3F4",
                              marginBottom: "3px",
                            }}
                          >
                            <Col span={8}>{add.qty}</Col>
                            <Col span={8}>
                              {this.state.posProductsList &&
                                this.state.posProductsList.length > 0 &&
                                this.state.posProductsList.filter(
                                  (ii) => ii.id === add.product,
                                ).length > 0 &&
                                this.state.posProductsList.filter(
                                  (ii) => ii.id === add.product,
                                )[0].name}
                            </Col>
                            <Col span={8}>{add.totalNetLine}</Col>
                          </Row>
                        ))}
                    </React.Fragment>
                  ))}
              </Modal>
            )}
            {/* <Modal
              className="orderCOmpleteModal"
              visible={this.state.orderCOmpleteModal}
              title={this.lang.BUTTON.ORDER_PAID_MODAL_TITLE}
              onCancel={() => {
                this.setState({ orderCOmpleteModal: false });
                this.props.posStorageAction({ pos: false });
                this.setState({ pos: false }, () => {
                  this.onComponentDidMountRender();
                });
              }}
              onOk={() => {
                this.setState({ orderCOmpleteModal: false });
                this.props.posStorageAction({ pos: false });
                this.setState({ pos: false }, () => {
                  this.onComponentDidMountRender();
                });
              }}
              footer={false}
            >
              <div className="order-complete-modal">
                <div className="success-animation">
                  <IoMdCheckmarkCircleOutline />
                </div>

                <h1 className="success-title">
                  {this.lang.BUTTON.ORDER_PAID_MODAL_MESG ||
                    "Payment Successful!"}
                </h1>

                <div className="amount-container">
                  <span className="amount-label">
                    {this.lang.BUTTON.ORDER_PAID_MODAL_TITLE}
                  </span>
                  <div className="amount-value">
                    <span className="currency">SAR</span>
                    <span className="amount">
                      {Number(
                        this.state.changeAmountOnOrderComplete || 0,
                      ).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </Modal> */}
            {this.state.online_orders_listShow && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <p className="title">{this.lang.BUTTON.ONLINE_ORDERS_MODAL}</p>
                <Table
                  style={{ marginTop: "10px" }}
                  columns={this.onlineOrdersColumns}
                  dataSource={this.state.online_orders_list}
                  rowKey="id"
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: (event) => {
                        if (!record.isView) {
                          axios({
                            url: API_URL + "updateOnlineOrderView",
                            method: "POST",
                            headers: {
                              Authorization:
                                localStorage.getItem("tokenType") +
                                " " +
                                localStorage.getItem("accessToken"),
                              "Content-Type": "application/json",
                            },
                            data: {
                              id: record.id,
                              lang: localStorage.getItem("lang"),
                            },
                          })
                            .then((res) => {
                              this.getOnlineOrders();
                            })
                            .catch((err) => {});
                        }
                        this.shoWdetailOnlineOrder(record);
                      },
                    };
                  }}
                />
              </div>
            )}
            {this.state.onlineOrdersListOpens && (
              <div className="wrapperPopupNav">
                <i onClick={this.cosleAllPopup} className="close">
                  <IoMdClose />{" "}
                </i>
                <div style={{ width: "100%" }}>
                  <OnlineOrdersList {...this.props} />
                </div>
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    posStorage: state.posStorage,
    userName: state.user.name,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    posStorageAction: (payload) => dispatch(posStorageAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(PosContainer);
